// // // screens/admin/AdminDashboard.jsx
// // import React, { useState, useEffect, useRef } from 'react';
// // import { useTheme } from '../../hooks/useTheme';
// // import { useAuth } from '../../providers/AuthProvider';
// // import { useToast } from '../../providers/ToastProvider';
// // import { useNavigate } from 'react-router-dom';
// // import {
// //     Users,
// //     ShoppingBag,
// //     TrendingUp,
// //     DollarSign,
// //     Package,
// //     Wallet,
// //     BarChart3,
// //     Clock,
// //     CheckCircle,
// //     AlertCircle,
// //     ChevronRight,
// //     Download,
// //     RefreshCw,
// //     ArrowUp,
// //     ArrowDown,
// //     UserPlus,
// //     ShoppingCart,
// //     Calendar,
// //     ChevronLeft,
// //     ChevronDown,
// //     Filter,
// //     Grid,
// //     List,
// //     PieChart,
// //     Activity,
// //     Award,
// //     Zap,
// //     Sparkles
// // } from 'lucide-react';

// // const AdminDashboard = () => {
// //     const { colors } = useTheme();
// //     const { user, authFetch } = useAuth();
// //     const { showToast } = useToast();
// //     const navigate = useNavigate();

// //     const [loading, setLoading] = useState(true);
// //     const [stats, setStats] = useState(null);
// //     const [walletBalance, setWalletBalance] = useState(0);
// //     const [recentOrders, setRecentOrders] = useState([]);
// //     const [recentUsers, setRecentUsers] = useState([]);
// //     const [topPackages, setTopPackages] = useState([]);
// //     const [selectedPeriod, setSelectedPeriod] = useState('weekly');
// //     const [chartData, setChartData] = useState(null);
// //     const [activeChartTab, setActiveChartTab] = useState('revenue');
// //     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

// //     // Animation refs for chart bars
// //     const chartRefs = useRef({});
// //     const [animating, setAnimating] = useState(false);

// //     // Handle resize
// //     useEffect(() => {
// //         const handleResize = () => {
// //             setIsMobile(window.innerWidth <= 768);
// //         };
// //         window.addEventListener('resize', handleResize);
// //         return () => window.removeEventListener('resize', handleResize);
// //     }, []);

// //     useEffect(() => {
// //         fetchDashboardData();
// //     }, []);

// //     useEffect(() => {
// //         if (stats?.admin?.weekly) {
// //             const weeklyData = stats.admin.weekly;
// //             const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// //             const revenueData = days.map(day => {
// //                 const found = weeklyData.revenue?.find(r => r.day === day);
// //                 return found ? found.value : 0;
// //             });
// //             const profitData = days.map(day => {
// //                 const found = weeklyData.profit?.find(r => r.day === day);
// //                 return found ? found.value : 0;
// //             });
// //             const ordersData = days.map(day => {
// //                 const found = weeklyData.orders?.find(r => r.day === day);
// //                 return found ? found.value : 0;
// //             });
// //             const usersData = days.map(day => {
// //                 const found = weeklyData.new_users?.find(r => r.day === day);
// //                 return found ? found.value : 0;
// //             });

// //             setChartData({
// //                 labels: days,
// //                 revenue: revenueData,
// //                 profit: profitData,
// //                 orders: ordersData,
// //                 users: usersData,
// //                 summary: weeklyData.summary || {}
// //             });

// //             setTimeout(() => setAnimating(true), 300);
// //         }
// //     }, [stats]);

// //     const fetchDashboardData = async () => {
// //         try {
// //             setLoading(true);
// //             setAnimating(false);

// //             const statsResponse = await authFetch('/accounts/dashboard/stats/');
// //             const statsData = await statsResponse.json();
// //             if (statsResponse.ok && statsData.status === 'success') {
// //                 setStats(statsData.data);
// //                 setWalletBalance(parseFloat(statsData.data.wallet_balance || 0));
// //             }

// //             const ordersResponse = await authFetch('/data/orders/?page_size=5&ordering=-created_at');
// //             const ordersData = await ordersResponse.json();
// //             if (ordersResponse.ok && ordersData.status === 'success') {
// //                 setRecentOrders(ordersData.data || []);
// //             }

// //             const usersResponse = await authFetch('/accounts/users/?page_size=5&ordering=-date_joined');
// //             const usersData = await usersResponse.json();
// //             if (usersResponse.ok && usersData.status === 'success') {
// //                 setRecentUsers(usersData.data || []);
// //             }

// //             const packagesResponse = await authFetch('/data/packages/?is_active=true');
// //             const packagesData = await packagesResponse.json();
// //             if (packagesResponse.ok && packagesData.status === 'success') {
// //                 const sorted = (packagesData.data || [])
// //                     .filter(p => p.sales_count > 0)
// //                     .sort((a, b) => (b.sales_count || 0) - (a.sales_count || 0))
// //                     .slice(0, 4);
// //                 setTopPackages(sorted);
// //             }

// //         } catch (error) {
// //             console.error('Error fetching dashboard data:', error);
// //             showToast('Failed to load dashboard data', 'error');
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     const getStatusColor = (status) => {
// //         const colors = {
// //             'COMPLETED': '#10B981',
// //             'PROCESSING': '#3B82F6',
// //             'PENDING': '#F59E0B',
// //             'FAILED': '#EF4444',
// //             'CANCELLED': '#6B7280',
// //         };
// //         return colors[status] || '#6B7280';
// //     };

// //     const getStatusIcon = (status) => {
// //         const icons = {
// //             'COMPLETED': <CheckCircle size={14} />,
// //             'PROCESSING': <RefreshCw size={14} />,
// //             'PENDING': <Clock size={14} />,
// //             'FAILED': <AlertCircle size={14} />,
// //             'CANCELLED': <AlertCircle size={14} />,
// //         };
// //         return icons[status] || null;
// //     };

// //     const getStatusLabel = (status) => {
// //         if (!status) return 'N/A';
// //         return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
// //     };

// //     const getRoleBadgeColor = (role) => {
// //         const colors = {
// //             'ADMIN': '#EF4444',
// //             'AGENT': '#3B82F6',
// //             'SUB_AGENT': '#8B5CF6',
// //             'CUSTOMER': '#10B981',
// //         };
// //         return colors[role] || '#6B7280';
// //     };

// //     const getRoleLabel = (role) => {
// //         const labels = {
// //             'ADMIN': 'Admin',
// //             'AGENT': 'Agent',
// //             'SUB_AGENT': 'Sub Agent',
// //             'CUSTOMER': 'Customer',
// //         };
// //         return labels[role] || role;
// //     };

// //     const formatDate = (dateString) => {
// //         if (!dateString) return 'N/A';
// //         try {
// //             const date = new Date(dateString);
// //             return date.toLocaleDateString('en-US', {
// //                 month: 'short',
// //                 day: 'numeric',
// //                 hour: '2-digit',
// //                 minute: '2-digit',
// //             });
// //         } catch {
// //             return 'N/A';
// //         }
// //     };

// //     const adminStats = stats?.admin || {};
// //     const totalRevenue = parseFloat(adminStats.total_revenue || 0);
// //     const totalOrders = adminStats.total_transactions || 0;
// //     const totalUsers = adminStats.total_users || 0;
// //     const totalProfit = parseFloat(adminStats.total_profit || 0);
// //     const pendingOrders = adminStats.pending_orders || 0;
// //     const todayOrders = adminStats.today_orders || 0;
// //     const totalAgents = adminStats.total_agents || 0;
// //     const totalSubAgents = adminStats.total_sub_agents || 0;
// //     const totalCustomers = adminStats.total_customers || 0;

// //     const renderChart = () => {
// //         if (!chartData) return null;

// //         const dataMap = {
// //             revenue: { data: chartData.revenue, color: colors.btnBg, label: 'Revenue' },
// //             profit: { data: chartData.profit, color: '#10B981', label: 'Profit' },
// //             orders: { data: chartData.orders, color: '#F59E0B', label: 'Orders' },
// //             users: { data: chartData.users, color: '#8B5CF6', label: 'New Users' },
// //         };

// //         const current = dataMap[activeChartTab];
// //         const maxValue = Math.max(...current.data, 1);
// //         const labels = chartData.labels;

// //         return (
// //             <div style={{
// //                 width: '100%',
// //                 height: '100%',
// //                 minHeight: isMobile ? '160px' : '200px',
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 gap: '6px',
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     marginBottom: '6px',
// //                     flexWrap: 'wrap',
// //                     gap: '6px',
// //                 }}>
// //                     <span style={{
// //                         fontSize: isMobile ? '11px' : '13px',
// //                         fontWeight: '600',
// //                         color: colors.secondaryText,
// //                     }}>
// //                         {current.label} Overview
// //                     </span>
// //                     <div style={{
// //                         display: 'flex',
// //                         gap: '3px',
// //                         flexWrap: 'wrap',
// //                     }}>
// //                         {['revenue', 'profit', 'orders', 'users'].map((tab) => (
// //                             <button
// //                                 key={tab}
// //                                 onClick={() => setActiveChartTab(tab)}
// //                                 style={{
// //                                     padding: isMobile ? '3px 8px' : '4px 10px',
// //                                     borderRadius: '5px',
// //                                     border: 'none',
// //                                     backgroundColor: activeChartTab === tab ? colors.btnBg : 'transparent',
// //                                     color: activeChartTab === tab ? colors.btnText : colors.secondaryText,
// //                                     cursor: 'pointer',
// //                                     fontSize: isMobile ? '8px' : '10px',
// //                                     fontWeight: activeChartTab === tab ? '600' : '500',
// //                                     transition: 'all 0.2s ease',
// //                                     textTransform: 'capitalize',
// //                                 }}
// //                             >
// //                                 {tab}
// //                             </button>
// //                         ))}
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     display: 'flex',
// //                     alignItems: 'flex-end',
// //                     height: isMobile ? '120px' : '160px',
// //                     gap: isMobile ? '4px' : '6px',
// //                     padding: '0 2px',
// //                     position: 'relative',
// //                 }}>
// //                     {current.data.map((value, index) => {
// //                         const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
// //                         const barHeight = Math.max(percentage, 4);

// //                         return (
// //                             <div
// //                                 key={index}
// //                                 style={{
// //                                     flex: 1,
// //                                     display: 'flex',
// //                                     flexDirection: 'column',
// //                                     alignItems: 'center',
// //                                     gap: isMobile ? '2px' : '4px',
// //                                     height: '100%',
// //                                     justifyContent: 'flex-end',
// //                                 }}
// //                             >
// //                                 <div style={{
// //                                     width: '100%',
// //                                     maxWidth: isMobile ? '20px' : '32px',
// //                                     height: `${animating ? barHeight : 0}%`,
// //                                     minHeight: animating ? '4px' : '0',
// //                                     background: `linear-gradient(180deg, ${current.color}, ${current.color}88)`,
// //                                     borderRadius: '3px 3px 0 0',
// //                                     transition: 'height 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
// //                                     position: 'relative',
// //                                     boxShadow: `0 2px 8px ${current.color}33`,
// //                                 }}>
// //                                     {animating && value > 0 && (
// //                                         <div style={{
// //                                             position: 'absolute',
// //                                             top: isMobile ? '-14px' : '-18px',
// //                                             left: '50%',
// //                                             transform: 'translateX(-50%)',
// //                                             fontSize: isMobile ? '7px' : '9px',
// //                                             fontWeight: '700',
// //                                             color: current.color,
// //                                             opacity: 0.8,
// //                                             whiteSpace: 'nowrap',
// //                                         }}>
// //                                             {value}
// //                                         </div>
// //                                     )}
// //                                 </div>
// //                                 <span style={{
// //                                     fontSize: isMobile ? '7px' : '9px',
// //                                     color: colors.secondaryText,
// //                                     fontWeight: '500',
// //                                 }}>
// //                                     {labels[index]}
// //                                 </span>
// //                             </div>
// //                         );
// //                     })}
// //                 </div>
// //             </div>
// //         );
// //     };

// //     if (loading) {
// //         return (
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'center',
// //                 alignItems: 'center',
// //                 minHeight: '400px',
// //                 flexDirection: 'column',
// //                 gap: '16px',
// //             }}>
// //                 <div className="spinner" style={{
// //                     width: '40px',
// //                     height: '40px',
// //                     border: `3px solid ${colors.border}`,
// //                     borderTop: `3px solid ${colors.btnBg}`,
// //                     borderRadius: '50%',
// //                     animation: 'spin 1s linear infinite',
// //                 }} />
// //                 <span style={{ color: colors.secondaryText, fontSize: '14px' }}>
// //                     Loading dashboard...
// //                 </span>
// //             </div>
// //         );
// //     }

// //     return (
// //         <div style={{
// //             maxWidth: '1200px',
// //             margin: '0 auto',
// //             padding: '0 12px 24px',
// //             width: '100%',
// //             boxSizing: 'border-box',
// //         }}>
// //             {/* Header */}
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'flex-start',
// //                 marginBottom: '16px',
// //                 flexWrap: 'wrap',
// //                 gap: '10px',
// //             }}>
// //                 <div>
// //                     <h1 style={{
// //                         fontSize: isMobile ? 'clamp(20px, 5vw, 24px)' : 'clamp(24px, 2.5vw, 32px)',
// //                         fontWeight: '700',
// //                         color: colors.heading,
// //                         margin: '0 0 2px 0',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '8px',
// //                         flexWrap: 'wrap',
// //                     }}>
// //                         <Activity size={isMobile ? 20 : 24} style={{ color: colors.btnBg }} />
// //                         Dashboard
// //                     </h1>
// //                     <p style={{
// //                         color: colors.secondaryText,
// //                         margin: 0,
// //                         fontSize: isMobile ? '12px' : '13px',
// //                     }}>
// //                         Welcome back, {user?.first_name || user?.username || 'Admin'}
// //                     </p>
// //                 </div>
// //                 <div style={{
// //                     display: 'flex',
// //                     gap: '6px',
// //                     alignItems: 'center',
// //                     flexWrap: 'wrap',
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         gap: '2px',
// //                         padding: '2px',
// //                         backgroundColor: colors.raisedBg,
// //                         borderRadius: '6px',
// //                         border: `1px solid ${colors.border}`,
// //                     }}>
// //                         {['daily', 'weekly', 'monthly'].map((period) => (
// //                             <button
// //                                 key={period}
// //                                 onClick={() => setSelectedPeriod(period)}
// //                                 style={{
// //                                     padding: isMobile ? '3px 8px' : '4px 10px',
// //                                     borderRadius: '4px',
// //                                     border: 'none',
// //                                     backgroundColor: selectedPeriod === period ? colors.btnBg : 'transparent',
// //                                     color: selectedPeriod === period ? colors.btnText : colors.secondaryText,
// //                                     cursor: 'pointer',
// //                                     fontSize: isMobile ? '8px' : '10px',
// //                                     fontWeight: selectedPeriod === period ? '600' : '500',
// //                                     transition: 'all 0.2s',
// //                                     textTransform: 'capitalize',
// //                                 }}
// //                             >
// //                                 {period}
// //                             </button>
// //                         ))}
// //                     </div>
// //                     <button
// //                         onClick={fetchDashboardData}
// //                         style={{
// //                             padding: isMobile ? '4px 10px' : '6px 12px',
// //                             borderRadius: '6px',
// //                             border: `1px solid ${colors.border}`,
// //                             backgroundColor: colors.raisedBg,
// //                             color: colors.text,
// //                             cursor: 'pointer',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '3px',
// //                             fontSize: isMobile ? '10px' : '12px',
// //                             transition: 'all 0.2s',
// //                             whiteSpace: 'nowrap',
// //                         }}
// //                         onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
// //                         onMouseLeave={(e) => e.currentTarget.style.background = colors.raisedBg}
// //                     >
// //                         <RefreshCw size={isMobile ? 12 : 14} />
// //                         {!isMobile && 'Refresh'}
// //                     </button>
// //                 </div>
// //             </div>

// //             {/* Stats Grid - Fixed Responsive with proper alignment */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
// //                 gap: isMobile ? '8px' : '10px',
// //                 marginBottom: isMobile ? '12px' : '20px',
// //                 width: '100%',
// //                 boxSizing: 'border-box',
// //             }}>
// //                 <StatCard
// //                     icon={<DollarSign size={isMobile ? 16 : 18} />}
// //                     label="Revenue"
// //                     value={`₵${totalRevenue.toLocaleString()}`}
// //                     change="+12.5%"
// //                     positive={true}
// //                     color={colors.btnBg}
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <StatCard
// //                     icon={<ShoppingBag size={isMobile ? 16 : 18} />}
// //                     label="Orders"
// //                     value={totalOrders}
// //                     change={`${pendingOrders} pending`}
// //                     positive={true}
// //                     color="#3B82F6"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <StatCard
// //                     icon={<Users size={isMobile ? 16 : 18} />}
// //                     label="Users"
// //                     value={totalUsers}
// //                     change={`${totalAgents} agents`}
// //                     positive={true}
// //                     color="#8B5CF6"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <StatCard
// //                     icon={<TrendingUp size={isMobile ? 16 : 18} />}
// //                     label="Profit"
// //                     value={`₵${totalProfit.toLocaleString()}`}
// //                     change="+8.2%"
// //                     positive={true}
// //                     color="#10B981"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //             </div>

// //             {/* Quick Stats Row - Fixed Responsive */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
// //                 gap: isMobile ? '6px' : '8px',
// //                 marginBottom: isMobile ? '12px' : '20px',
// //                 width: '100%',
// //                 boxSizing: 'border-box',
// //             }}>
// //                 <QuickStat
// //                     label="Today's Orders"
// //                     value={todayOrders}
// //                     icon={<ShoppingCart size={isMobile ? 14 : 16} />}
// //                     color={colors.btnBg}
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <QuickStat
// //                     label="Wallet"
// //                     value={`₵${walletBalance.toFixed(2)}`}
// //                     icon={<Wallet size={isMobile ? 14 : 16} />}
// //                     color="#8B5CF6"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <QuickStat
// //                     label="Pending"
// //                     value={pendingOrders}
// //                     icon={<Clock size={isMobile ? 14 : 16} />}
// //                     color="#F59E0B"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //                 <QuickStat
// //                     label="Sub Agents"
// //                     value={totalSubAgents}
// //                     icon={<Users size={isMobile ? 14 : 16} />}
// //                     color="#3B82F6"
// //                     colors={colors}
// //                     isMobile={isMobile}
// //                 />
// //             </div>

// //             {/* Chart Section */}
// //             <div style={{
// //                 backgroundColor: colors.raisedBg,
// //                 borderRadius: '12px',
// //                 border: `1px solid ${colors.border}`,
// //                 padding: isMobile ? '12px 14px' : '16px 18px',
// //                 marginBottom: isMobile ? '12px' : '20px',
// //                 boxShadow: `0 2px 8px ${colors.shadow}`,
// //                 width: '100%',
// //                 boxSizing: 'border-box',
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     marginBottom: isMobile ? '8px' : '12px',
// //                     flexWrap: 'wrap',
// //                     gap: '6px',
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '6px',
// //                     }}>
// //                         <BarChart3 size={isMobile ? 16 : 18} style={{ color: colors.btnBg }} />
// //                         <span style={{
// //                             fontWeight: '600',
// //                             fontSize: isMobile ? '13px' : '15px',
// //                             color: colors.heading,
// //                         }}>
// //                             Analytics
// //                         </span>
// //                     </div>
// //                     {chartData?.summary && (
// //                         <div style={{
// //                             display: 'flex',
// //                             gap: isMobile ? '6px' : '12px',
// //                             fontSize: isMobile ? '9px' : '11px',
// //                             color: colors.secondaryText,
// //                             flexWrap: 'wrap',
// //                         }}>
// //                             <span>Orders: <strong style={{ color: colors.text }}>{chartData.summary.total_orders || 0}</strong></span>
// //                             <span>Revenue: <strong style={{ color: colors.text }}>₵{(chartData.summary.total_revenue || 0).toFixed(2)}</strong></span>
// //                             {!isMobile && (
// //                                 <span>Users: <strong style={{ color: colors.text }}>{chartData.summary.total_new_users || 0}</strong></span>
// //                             )}
// //                         </div>
// //                     )}
// //                 </div>
// //                 <div style={{
// //                     width: '100%',
// //                     minHeight: isMobile ? '160px' : '220px',
// //                 }}>
// //                     {renderChart()}
// //                 </div>
// //             </div>

// //             {/* Two Column Layout - Fixed Responsive */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
// //                 gap: isMobile ? '12px' : '16px',
// //                 marginBottom: isMobile ? '12px' : '20px',
// //                 width: '100%',
// //                 boxSizing: 'border-box',
// //             }}>
// //                 {/* Recent Orders */}
// //                 <div style={{
// //                     backgroundColor: colors.raisedBg,
// //                     borderRadius: '12px',
// //                     border: `1px solid ${colors.border}`,
// //                     overflow: 'hidden',
// //                     width: '100%',
// //                     boxSizing: 'border-box',
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'center',
// //                         padding: isMobile ? '10px 12px' : '14px 16px',
// //                         borderBottom: `1px solid ${colors.border}`,
// //                         flexWrap: 'wrap',
// //                         gap: '6px',
// //                     }}>
// //                         <div style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                         }}>
// //                             <ShoppingBag size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
// //                             <span style={{
// //                                 fontWeight: '600',
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 color: colors.heading,
// //                             }}>
// //                                 Recent Orders
// //                             </span>
// //                         </div>
// //                         <button
// //                             onClick={() => navigate('/orders')}
// //                             style={{
// //                                 fontSize: isMobile ? '11px' : '12px',
// //                                 color: colors.btnBg,
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '2px',
// //                                 fontWeight: '500',
// //                             }}
// //                         >
// //                             View All <ChevronRight size={isMobile ? 12 : 14} />
// //                         </button>
// //                     </div>
// //                     <div style={{
// //                         overflowX: 'auto',
// //                         WebkitOverflowScrolling: 'touch',
// //                         width: '100%',
// //                     }}>
// //                         {recentOrders && recentOrders.length > 0 ? (
// //                             recentOrders.map((order) => (
// //                                 <div
// //                                     key={order.id}
// //                                     style={{
// //                                         display: 'grid',
// //                                         gridTemplateColumns: isMobile ? '0.7fr 1fr 0.6fr 0.6fr' : '0.8fr 1fr 0.7fr 0.7fr',
// //                                         padding: isMobile ? '8px 12px' : '10px 16px',
// //                                         borderBottom: `1px solid ${colors.border}`,
// //                                         alignItems: 'center',
// //                                         fontSize: isMobile ? '11px' : '12px',
// //                                         transition: 'background 0.2s',
// //                                         gap: isMobile ? '3px' : '4px',
// //                                         minWidth: isMobile ? '280px' : 'auto',
// //                                     }}
// //                                     onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
// //                                     onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
// //                                 >
// //                                     <span style={{
// //                                         fontWeight: '500',
// //                                         color: colors.heading,
// //                                         fontSize: isMobile ? '10px' : '11px',
// //                                     }}>
// //                                         {order.id?.slice(0, 8) || 'N/A'}
// //                                     </span>
// //                                     <span style={{
// //                                         color: colors.text,
// //                                         overflow: 'hidden',
// //                                         textOverflow: 'ellipsis',
// //                                         whiteSpace: 'nowrap',
// //                                         fontSize: isMobile ? '10px' : '12px',
// //                                     }}>
// //                                         {order.customer?.username || order.customer_username || 'N/A'}
// //                                     </span>
// //                                     <span style={{
// //                                         fontWeight: '600',
// //                                         color: colors.btnBg,
// //                                         fontSize: isMobile ? '11px' : '12px',
// //                                     }}>
// //                                         ₵{order.customer_price || '0.00'}
// //                                     </span>
// //                                     <span style={{
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         gap: '2px',
// //                                         color: getStatusColor(order.status),
// //                                         fontSize: isMobile ? '9px' : '10px',
// //                                         fontWeight: '600',
// //                                         textTransform: 'capitalize',
// //                                     }}>
// //                                         {getStatusIcon(order.status)}
// //                                         {isMobile ? getStatusLabel(order.status).slice(0, 3) : getStatusLabel(order.status)}
// //                                     </span>
// //                                 </div>
// //                             ))
// //                         ) : (
// //                             <div style={{
// //                                 padding: isMobile ? '20px 12px' : '30px 16px',
// //                                 textAlign: 'center',
// //                                 color: colors.secondaryText,
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                             }}>
// //                                 No recent orders
// //                             </div>
// //                         )}
// //                     </div>
// //                 </div>

// //                 {/* Recent Users */}
// //                 <div style={{
// //                     backgroundColor: colors.raisedBg,
// //                     borderRadius: '12px',
// //                     border: `1px solid ${colors.border}`,
// //                     overflow: 'hidden',
// //                     width: '100%',
// //                     boxSizing: 'border-box',
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'center',
// //                         padding: isMobile ? '10px 12px' : '14px 16px',
// //                         borderBottom: `1px solid ${colors.border}`,
// //                         flexWrap: 'wrap',
// //                         gap: '6px',
// //                     }}>
// //                         <div style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '6px',
// //                         }}>
// //                             <Users size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
// //                             <span style={{
// //                                 fontWeight: '600',
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 color: colors.heading,
// //                             }}>
// //                                 New Users
// //                             </span>
// //                         </div>
// //                         <button
// //                             onClick={() => navigate('/admin/users')}
// //                             style={{
// //                                 fontSize: isMobile ? '11px' : '12px',
// //                                 color: colors.btnBg,
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '2px',
// //                                 fontWeight: '500',
// //                             }}
// //                         >
// //                             View All <ChevronRight size={isMobile ? 12 : 14} />
// //                         </button>
// //                     </div>
// //                     <div>
// //                         {recentUsers && recentUsers.length > 0 ? (
// //                             recentUsers.map((user) => (
// //                                 <div
// //                                     key={user.id}
// //                                     style={{
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         justifyContent: 'space-between',
// //                                         padding: isMobile ? '6px 12px' : '8px 16px',
// //                                         borderBottom: `1px solid ${colors.border}`,
// //                                         transition: 'background 0.2s',
// //                                         gap: '6px',
// //                                     }}
// //                                     onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
// //                                     onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
// //                                 >
// //                                     <div style={{
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         gap: '6px',
// //                                         minWidth: 0,
// //                                         flex: 1,
// //                                     }}>
// //                                         <div style={{
// //                                             width: isMobile ? '24px' : '28px',
// //                                             height: isMobile ? '24px' : '28px',
// //                                             borderRadius: '50%',
// //                                             backgroundColor: `${getRoleBadgeColor(user.role)}20`,
// //                                             display: 'flex',
// //                                             alignItems: 'center',
// //                                             justifyContent: 'center',
// //                                             color: getRoleBadgeColor(user.role),
// //                                             fontSize: isMobile ? '10px' : '12px',
// //                                             fontWeight: '600',
// //                                             flexShrink: 0,
// //                                         }}>
// //                                             {user.first_name?.[0] || user.username?.[0] || 'U'}
// //                                         </div>
// //                                         <div style={{ minWidth: 0, flex: 1 }}>
// //                                             <div style={{
// //                                                 fontSize: isMobile ? '11px' : '12px',
// //                                                 fontWeight: '500',
// //                                                 color: colors.heading,
// //                                                 overflow: 'hidden',
// //                                                 textOverflow: 'ellipsis',
// //                                                 whiteSpace: 'nowrap',
// //                                             }}>
// //                                                 {user.first_name || user.username}
// //                                                 {user.last_name && ` ${user.last_name}`}
// //                                             </div>
// //                                             <div style={{
// //                                                 fontSize: isMobile ? '9px' : '10px',
// //                                                 color: colors.secondaryText,
// //                                                 overflow: 'hidden',
// //                                                 textOverflow: 'ellipsis',
// //                                                 whiteSpace: 'nowrap',
// //                                             }}>
// //                                                 {user.email}
// //                                             </div>
// //                                         </div>
// //                                     </div>
// //                                     <span style={{
// //                                         fontSize: isMobile ? '8px' : '9px',
// //                                         padding: isMobile ? '1px 6px' : '1px 8px',
// //                                         borderRadius: '8px',
// //                                         backgroundColor: `${getRoleBadgeColor(user.role)}20`,
// //                                         color: getRoleBadgeColor(user.role),
// //                                         fontWeight: '600',
// //                                         textTransform: 'uppercase',
// //                                         flexShrink: 0,
// //                                         whiteSpace: 'nowrap',
// //                                     }}>
// //                                         {isMobile ? getRoleLabel(user.role).slice(0, 4) : getRoleLabel(user.role)}
// //                                     </span>
// //                                 </div>
// //                             ))
// //                         ) : (
// //                             <div style={{
// //                                 padding: isMobile ? '20px 12px' : '30px 16px',
// //                                 textAlign: 'center',
// //                                 color: colors.secondaryText,
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                             }}>
// //                                 No recent users
// //                             </div>
// //                         )}
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Top Packages */}
// //             <div style={{
// //                 backgroundColor: colors.raisedBg,
// //                 borderRadius: '12px',
// //                 border: `1px solid ${colors.border}`,
// //                 overflow: 'hidden',
// //                 width: '100%',
// //                 boxSizing: 'border-box',
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     padding: isMobile ? '10px 12px' : '14px 16px',
// //                     borderBottom: `1px solid ${colors.border}`,
// //                     flexWrap: 'wrap',
// //                     gap: '6px',
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '6px',
// //                     }}>
// //                         <Award size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
// //                         <span style={{
// //                             fontWeight: '600',
// //                             fontSize: isMobile ? '13px' : '14px',
// //                             color: colors.heading,
// //                         }}>
// //                             Top Packages
// //                         </span>
// //                     </div>
// //                     <span style={{
// //                         fontSize: isMobile ? '9px' : '11px',
// //                         color: colors.secondaryText,
// //                     }}>
// //                         By sales volume
// //                     </span>
// //                 </div>
// //                 <div style={{
// //                     display: 'grid',
// //                     gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(170px, 1fr))',
// //                     gap: isMobile ? '6px' : '10px',
// //                     padding: isMobile ? '10px 12px' : '14px 16px',
// //                     width: '100%',
// //                     boxSizing: 'border-box',
// //                 }}>
// //                     {topPackages && topPackages.length > 0 ? (
// //                         topPackages.map((pkg, index) => (
// //                             <div
// //                                 key={index}
// //                                 style={{
// //                                     padding: isMobile ? '8px 10px' : '12px 14px',
// //                                     backgroundColor: colors.mainBg,
// //                                     borderRadius: '8px',
// //                                     border: `1px solid ${colors.border}`,
// //                                     display: 'flex',
// //                                     justifyContent: 'space-between',
// //                                     alignItems: 'center',
// //                                     transition: 'all 0.3s ease',
// //                                     width: '100%',
// //                                     boxSizing: 'border-box',
// //                                 }}
// //                                 onMouseEnter={(e) => {
// //                                     e.currentTarget.style.transform = 'translateY(-2px)';
// //                                     e.currentTarget.style.boxShadow = `0 4px 12px ${colors.shadow}`;
// //                                 }}
// //                                 onMouseLeave={(e) => {
// //                                     e.currentTarget.style.transform = 'translateY(0)';
// //                                     e.currentTarget.style.boxShadow = 'none';
// //                                 }}
// //                             >
// //                                 <div>
// //                                     <div style={{
// //                                         fontSize: isMobile ? '10px' : '12px',
// //                                         fontWeight: '600',
// //                                         color: colors.heading,
// //                                         textTransform: 'uppercase',
// //                                     }}>
// //                                         {pkg.network}
// //                                     </div>
// //                                     <div style={{
// //                                         fontSize: isMobile ? '9px' : '11px',
// //                                         color: colors.secondaryText,
// //                                     }}>
// //                                         {pkg.size_gb}GB • {pkg.sales_count || 0} sales
// //                                     </div>
// //                                 </div>
// //                                 <div style={{
// //                                     fontSize: isMobile ? '12px' : '14px',
// //                                     fontWeight: '700',
// //                                     color: colors.btnBg,
// //                                 }}>
// //                                     ₵{parseFloat(pkg.total_revenue || 0).toFixed(2)}
// //                                 </div>
// //                             </div>
// //                         ))
// //                     ) : (
// //                         <div style={{
// //                             padding: isMobile ? '20px 12px' : '30px 16px',
// //                             textAlign: 'center',
// //                             color: colors.secondaryText,
// //                             gridColumn: '1 / -1',
// //                             fontSize: isMobile ? '12px' : '13px',
// //                         }}>
// //                             No package data available
// //                         </div>
// //                     )}
// //                 </div>
// //             </div>

// //             <style>{`
// //                 @keyframes spin {
// //                     0% { transform: rotate(0deg); }
// //                     100% { transform: rotate(360deg); }
// //                 }

// //                 @keyframes slideUp {
// //                     from {
// //                         opacity: 0;
// //                         transform: translateY(20px);
// //                     }
// //                     to {
// //                         opacity: 1;
// //                         transform: translateY(0);
// //                     }
// //                 }

// //                 * {
// //                     box-sizing: border-box;
// //                 }

// //                 @media (max-width: 768px) {
// //                     .two-column-grid {
// //                         grid-template-columns: 1fr !important;
// //                     }
// //                 }

// //                 @media (max-width: 480px) {
// //                     .stat-card {
// //                         padding: 8px 10px !important;
// //                     }
                    
// //                     .stat-value {
// //                         font-size: 14px !important;
// //                     }
                    
// //                     .stat-label {
// //                         font-size: 9px !important;
// //                     }
// //                 }
// //             `}</style>
// //         </div>
// //     );
// // };

// // // Stat Card Component - Fixed width and alignment
// // const StatCard = ({ icon, label, value, change, positive, color, colors, isMobile }) => (
// //     <div style={{
// //         backgroundColor: colors.raisedBg,
// //         borderRadius: isMobile ? '10px' : '12px',
// //         padding: isMobile ? '10px 12px' : '14px 16px',
// //         border: `1px solid ${colors.border}`,
// //         transition: 'all 0.3s ease',
// //         width: '100%',
// //         boxSizing: 'border-box',
// //         display: 'flex',
// //         flexDirection: 'column',
// //     }}
// //     onMouseEnter={(e) => {
// //         e.currentTarget.style.transform = 'translateY(-3px)';
// //         e.currentTarget.style.boxShadow = `0 6px 20px ${colors.shadow}`;
// //     }}
// //     onMouseLeave={(e) => {
// //         e.currentTarget.style.transform = 'translateY(0)';
// //         e.currentTarget.style.boxShadow = 'none';
// //     }}>
// //         <div style={{
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'space-between',
// //             marginBottom: isMobile ? '2px' : '4px',
// //             width: '100%',
// //         }}>
// //             <span style={{
// //                 fontSize: isMobile ? '9px' : '11px',
// //                 color: colors.secondaryText,
// //                 fontWeight: '500',
// //                 whiteSpace: 'nowrap',
// //             }}>
// //                 {label}
// //             </span>
// //             <span style={{
// //                 color: color,
// //                 opacity: 0.7,
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 flexShrink: 0,
// //             }}>
// //                 {icon}
// //             </span>
// //         </div>
// //         <div style={{
// //             fontSize: isMobile ? 'clamp(16px, 4vw, 20px)' : 'clamp(18px, 2vw, 22px)',
// //             fontWeight: '700',
// //             color: colors.heading,
// //             width: '100%',
// //             overflow: 'hidden',
// //             textOverflow: 'ellipsis',
// //             whiteSpace: 'nowrap',
// //         }}>
// //             {value}
// //         </div>
// //         {change && (
// //             <div style={{
// //                 fontSize: isMobile ? '9px' : '11px',
// //                 color: positive ? '#10B981' : '#EF4444',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '2px',
// //                 marginTop: isMobile ? '1px' : '2px',
// //             }}>
// //                 {positive ? <ArrowUp size={isMobile ? 10 : 12} /> : <ArrowDown size={isMobile ? 10 : 12} />}
// //                 {change}
// //             </div>
// //         )}
// //     </div>
// // );

// // // Quick Stat Component - Fixed width and alignment
// // const QuickStat = ({ label, value, icon, color, colors, isMobile }) => (
// //     <div style={{
// //         backgroundColor: colors.raisedBg,
// //         borderRadius: isMobile ? '8px' : '10px',
// //         padding: isMobile ? '8px 10px' : '10px 14px',
// //         border: `1px solid ${colors.border}`,
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'space-between',
// //         width: '100%',
// //         boxSizing: 'border-box',
// //     }}>
// //         <div style={{ minWidth: 0, flex: 1 }}>
// //             <div style={{
// //                 fontSize: isMobile ? '8px' : '10px',
// //                 color: colors.secondaryText,
// //                 fontWeight: '500',
// //                 whiteSpace: 'nowrap',
// //             }}>
// //                 {label}
// //             </div>
// //             <div style={{
// //                 fontSize: isMobile ? 'clamp(14px, 3.5vw, 18px)' : '16px',
// //                 fontWeight: '700',
// //                 color: colors.heading,
// //                 overflow: 'hidden',
// //                 textOverflow: 'ellipsis',
// //                 whiteSpace: 'nowrap',
// //             }}>
// //                 {value}
// //             </div>
// //         </div>
// //         <span style={{
// //             color: color,
// //             opacity: 0.6,
// //             display: 'flex',
// //             alignItems: 'center',
// //             flexShrink: 0,
// //             marginLeft: '8px',
// //         }}>
// //             {icon}
// //         </span>
// //     </div>
// // );

// // export default AdminDashboard;
























// // screens/admin/AdminDashboard.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { useTheme } from '../../hooks/useTheme';
// import { useAuth } from '../../providers/AuthProvider';
// import { useToast } from '../../providers/ToastProvider';
// import { useNavigate } from 'react-router-dom';
// import {
//     Users,
//     ShoppingBag,
//     TrendingUp,
//     DollarSign,
//     Package,
//     Wallet,
//     BarChart3,
//     Clock,
//     CheckCircle,
//     AlertCircle,
//     ChevronRight,
//     Download,
//     RefreshCw,
//     ArrowUp,
//     ArrowDown,
//     UserPlus,
//     ShoppingCart,
//     Calendar,
//     ChevronLeft,
//     ChevronDown,
//     Filter,
//     Grid,
//     List,
//     PieChart,
//     Activity,
//     Award,
//     Zap,
//     Sparkles,
//     Edit2,
//     Save,
//     X,
//     Coins
// } from 'lucide-react';

// const AdminDashboard = () => {
//     const { colors } = useTheme();
//     const { user, authFetch } = useAuth();
//     const { showToast } = useToast();
//     const navigate = useNavigate();

//     const [loading, setLoading] = useState(true);
//     const [stats, setStats] = useState(null);
//     const [walletBalance, setWalletBalance] = useState(0);
//     const [recentOrders, setRecentOrders] = useState([]);
//     const [recentUsers, setRecentUsers] = useState([]);
//     const [topPackages, setTopPackages] = useState([]);
//     const [selectedPeriod, setSelectedPeriod] = useState('weekly');
//     const [chartData, setChartData] = useState(null);
//     const [activeChartTab, setActiveChartTab] = useState('revenue');
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     const [registrationFees, setRegistrationFees] = useState(null);
//     const [isEditingFees, setIsEditingFees] = useState(false);
//     const [editFeesData, setEditFeesData] = useState({ agent_registration_fee: '', sub_agent_registration_fee: '' });
//     const [isSavingFees, setIsSavingFees] = useState(false);

//     // Animation refs for chart bars
//     const chartRefs = useRef({});
//     const [animating, setAnimating] = useState(false);

//     // Handle resize
//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         fetchDashboardData();
//     }, []);

//     useEffect(() => {
//         if (stats?.admin?.weekly) {
//             const weeklyData = stats.admin.weekly;
//             const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//             const revenueData = days.map(day => {
//                 const found = weeklyData.revenue?.find(r => r.day === day);
//                 return found ? found.value : 0;
//             });
//             const profitData = days.map(day => {
//                 const found = weeklyData.profit?.find(r => r.day === day);
//                 return found ? found.value : 0;
//             });
//             const ordersData = days.map(day => {
//                 const found = weeklyData.orders?.find(r => r.day === day);
//                 return found ? found.value : 0;
//             });
//             const usersData = days.map(day => {
//                 const found = weeklyData.new_users?.find(r => r.day === day);
//                 return found ? found.value : 0;
//             });

//             setChartData({
//                 labels: days,
//                 revenue: revenueData,
//                 profit: profitData,
//                 orders: ordersData,
//                 users: usersData,
//                 summary: weeklyData.summary || {}
//             });

//             setTimeout(() => setAnimating(true), 300);
//         }
//     }, [stats]);

//     const fetchDashboardData = async () => {
//         try {
//             setLoading(true);
//             setAnimating(false);

//             // Fetch dashboard stats
//             const statsResponse = await authFetch('/accounts/dashboard/stats/');
//             const statsData = await statsResponse.json();
//             if (statsResponse.ok && statsData.status === 'success') {
//                 setStats(statsData.data);
//                 setWalletBalance(parseFloat(statsData.data.wallet_balance || 0));
//             }

//             // Fetch recent orders (last 5)
//             const ordersResponse = await authFetch('/data/orders/?page_size=5&ordering=-created_at');
//             const ordersData = await ordersResponse.json();
//             if (ordersResponse.ok && ordersData.status === 'success') {
//                 setRecentOrders(ordersData.data || []);
//             }

//             // Fetch recent users (last 5)
//             const usersResponse = await authFetch('/accounts/users/?page_size=5&ordering=-date_joined');
//             const usersData = await usersResponse.json();
//             if (usersResponse.ok && usersData.status === 'success') {
//                 setRecentUsers(usersData.data || []);
//             }

//             // Fetch top packages
//             const packagesResponse = await authFetch('/data/packages/?is_active=true');
//             const packagesData = await packagesResponse.json();
//             if (packagesResponse.ok && packagesData.status === 'success') {
//                 const sorted = (packagesData.data || [])
//                     .filter(p => p.sales_count > 0)
//                     .sort((a, b) => (b.sales_count || 0) - (a.sales_count || 0))
//                     .slice(0, 4);
//                 setTopPackages(sorted);
//             }

//             // Fetch registration fees
//             await fetchRegistrationFees();

//         } catch (error) {
//             console.error('Error fetching dashboard data:', error);
//             showToast('Failed to load dashboard data', 'error');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchRegistrationFees = async () => {
//         try {
//             const response = await authFetch('/accounts/registration-fees/');
//             const data = await response.json();
//             if (response.ok && data.status === 'success') {
//                 setRegistrationFees(data.data);
//                 setEditFeesData({
//                     agent_registration_fee: data.data.agent_registration_fee || '',
//                     sub_agent_registration_fee: data.data.sub_agent_registration_fee || '',
//                 });
//             }
//         } catch (error) {
//             console.error('Error fetching registration fees:', error);
//         }
//     };

//     const handleEditFees = () => {
//         setIsEditingFees(true);
//         setEditFeesData({
//             agent_registration_fee: registrationFees?.agent_registration_fee || '',
//             sub_agent_registration_fee: registrationFees?.sub_agent_registration_fee || '',
//         });
//     };

//     const handleCancelEditFees = () => {
//         setIsEditingFees(false);
//         setEditFeesData({
//             agent_registration_fee: registrationFees?.agent_registration_fee || '',
//             sub_agent_registration_fee: registrationFees?.sub_agent_registration_fee || '',
//         });
//     };

//     const handleSaveFees = async () => {
//         // Validate
//         const agentFee = parseFloat(editFeesData.agent_registration_fee);
//         const subAgentFee = parseFloat(editFeesData.sub_agent_registration_fee);

//         if (isNaN(agentFee) || agentFee < 0) {
//             showToast('Agent registration fee must be a valid positive number', 'error');
//             return;
//         }
//         if (isNaN(subAgentFee) || subAgentFee < 0) {
//             showToast('Sub-agent registration fee must be a valid positive number', 'error');
//             return;
//         }

//         setIsSavingFees(true);
//         try {
//             const response = await authFetch('/accounts/registration-fees/', {
//                 method: 'PUT',
//                 body: JSON.stringify({
//                     agent_registration_fee: agentFee.toFixed(2),
//                     sub_agent_registration_fee: subAgentFee.toFixed(2),
//                 }),
//             });

//             const data = await response.json();

//             if (response.ok && data.status === 'success') {
//                 showToast('Registration fees updated successfully!', 'success');
//                 setRegistrationFees(data.data);
//                 setIsEditingFees(false);
//             } else {
//                 showToast(data.message || 'Failed to update registration fees', 'error');
//             }
//         } catch (error) {
//             console.error('Error updating registration fees:', error);
//             showToast('Network error. Please try again.', 'error');
//         } finally {
//             setIsSavingFees(false);
//         }
//     };

//     const handleFeeInputChange = (e) => {
//         const { name, value } = e.target;
//         // Allow only numbers and decimal point
//         const cleaned = value.replace(/[^0-9.]/g, '');
//         setEditFeesData(prev => ({ ...prev, [name]: cleaned }));
//     };

//     const getStatusColor = (status) => {
//         const colors = {
//             'COMPLETED': '#10B981',
//             'PROCESSING': '#3B82F6',
//             'PENDING': '#F59E0B',
//             'FAILED': '#EF4444',
//             'CANCELLED': '#6B7280',
//         };
//         return colors[status] || '#6B7280';
//     };

//     const getStatusIcon = (status) => {
//         const icons = {
//             'COMPLETED': <CheckCircle size={14} />,
//             'PROCESSING': <RefreshCw size={14} />,
//             'PENDING': <Clock size={14} />,
//             'FAILED': <AlertCircle size={14} />,
//             'CANCELLED': <AlertCircle size={14} />,
//         };
//         return icons[status] || null;
//     };

//     const getStatusLabel = (status) => {
//         if (!status) return 'N/A';
//         return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
//     };

//     const getRoleBadgeColor = (role) => {
//         const colors = {
//             'ADMIN': '#EF4444',
//             'AGENT': '#3B82F6',
//             'SUB_AGENT': '#8B5CF6',
//             'CUSTOMER': '#10B981',
//         };
//         return colors[role] || '#6B7280';
//     };

//     const getRoleLabel = (role) => {
//         const labels = {
//             'ADMIN': 'Admin',
//             'AGENT': 'Agent',
//             'SUB_AGENT': 'Sub Agent',
//             'CUSTOMER': 'Customer',
//         };
//         return labels[role] || role;
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString('en-US', {
//                 month: 'short',
//                 day: 'numeric',
//                 hour: '2-digit',
//                 minute: '2-digit',
//             });
//         } catch {
//             return 'N/A';
//         }
//     };

//     const adminStats = stats?.admin || {};
//     const totalRevenue = parseFloat(adminStats.total_revenue || 0);
//     const totalOrders = adminStats.total_transactions || 0;
//     const totalUsers = adminStats.total_users || 0;
//     const totalProfit = parseFloat(adminStats.total_profit || 0);
//     const pendingOrders = adminStats.pending_orders || 0;
//     const todayOrders = adminStats.today_orders || 0;
//     const totalAgents = adminStats.total_agents || 0;
//     const totalSubAgents = adminStats.total_sub_agents || 0;
//     const totalCustomers = adminStats.total_customers || 0;

//     const renderChart = () => {
//         if (!chartData) return null;

//         const dataMap = {
//             revenue: { data: chartData.revenue, color: colors.btnBg, label: 'Revenue' },
//             profit: { data: chartData.profit, color: '#10B981', label: 'Profit' },
//             orders: { data: chartData.orders, color: '#F59E0B', label: 'Orders' },
//             users: { data: chartData.users, color: '#8B5CF6', label: 'New Users' },
//         };

//         const current = dataMap[activeChartTab];
//         const maxValue = Math.max(...current.data, 1);
//         const labels = chartData.labels;

//         return (
//             <div style={{
//                 width: '100%',
//                 height: '100%',
//                 minHeight: isMobile ? '160px' : '200px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '6px',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: '6px',
//                     flexWrap: 'wrap',
//                     gap: '6px',
//                 }}>
//                     <span style={{
//                         fontSize: isMobile ? '11px' : '13px',
//                         fontWeight: '600',
//                         color: colors.secondaryText,
//                     }}>
//                         {current.label} Overview
//                     </span>
//                     <div style={{
//                         display: 'flex',
//                         gap: '3px',
//                         flexWrap: 'wrap',
//                     }}>
//                         {['revenue', 'profit', 'orders', 'users'].map((tab) => (
//                             <button
//                                 key={tab}
//                                 onClick={() => setActiveChartTab(tab)}
//                                 style={{
//                                     padding: isMobile ? '3px 8px' : '4px 10px',
//                                     borderRadius: '5px',
//                                     border: 'none',
//                                     backgroundColor: activeChartTab === tab ? colors.btnBg : 'transparent',
//                                     color: activeChartTab === tab ? colors.btnText : colors.secondaryText,
//                                     cursor: 'pointer',
//                                     fontSize: isMobile ? '8px' : '10px',
//                                     fontWeight: activeChartTab === tab ? '600' : '500',
//                                     transition: 'all 0.2s ease',
//                                     textTransform: 'capitalize',
//                                 }}
//                             >
//                                 {tab}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'flex-end',
//                     height: isMobile ? '120px' : '160px',
//                     gap: isMobile ? '4px' : '6px',
//                     padding: '0 2px',
//                     position: 'relative',
//                 }}>
//                     {current.data.map((value, index) => {
//                         const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
//                         const barHeight = Math.max(percentage, 4);

//                         return (
//                             <div
//                                 key={index}
//                                 style={{
//                                     flex: 1,
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     gap: isMobile ? '2px' : '4px',
//                                     height: '100%',
//                                     justifyContent: 'flex-end',
//                                 }}
//                             >
//                                 <div style={{
//                                     width: '100%',
//                                     maxWidth: isMobile ? '20px' : '32px',
//                                     height: `${animating ? barHeight : 0}%`,
//                                     minHeight: animating ? '4px' : '0',
//                                     background: `linear-gradient(180deg, ${current.color}, ${current.color}88)`,
//                                     borderRadius: '3px 3px 0 0',
//                                     transition: 'height 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                                     position: 'relative',
//                                     boxShadow: `0 2px 8px ${current.color}33`,
//                                 }}>
//                                     {animating && value > 0 && (
//                                         <div style={{
//                                             position: 'absolute',
//                                             top: isMobile ? '-14px' : '-18px',
//                                             left: '50%',
//                                             transform: 'translateX(-50%)',
//                                             fontSize: isMobile ? '7px' : '9px',
//                                             fontWeight: '700',
//                                             color: current.color,
//                                             opacity: 0.8,
//                                             whiteSpace: 'nowrap',
//                                         }}>
//                                             {value}
//                                         </div>
//                                     )}
//                                 </div>
//                                 <span style={{
//                                     fontSize: isMobile ? '7px' : '9px',
//                                     color: colors.secondaryText,
//                                     fontWeight: '500',
//                                 }}>
//                                     {labels[index]}
//                                 </span>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>
//         );
//     };

//     if (loading) {
//         return (
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 minHeight: '400px',
//                 flexDirection: 'column',
//                 gap: '16px',
//             }}>
//                 <div className="spinner" style={{
//                     width: '40px',
//                     height: '40px',
//                     border: `3px solid ${colors.border}`,
//                     borderTop: `3px solid ${colors.btnBg}`,
//                     borderRadius: '50%',
//                     animation: 'spin 1s linear infinite',
//                 }} />
//                 <span style={{ color: colors.secondaryText, fontSize: '14px' }}>
//                     Loading dashboard...
//                 </span>
//             </div>
//         );
//     }

//     return (
//         <div style={{
//             maxWidth: '1200px',
//             margin: '0 auto',
//             padding: '0 12px 24px',
//             width: '100%',
//             boxSizing: 'border-box',
//         }}>
//             {/* Header */}
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'flex-start',
//                 marginBottom: '16px',
//                 flexWrap: 'wrap',
//                 gap: '10px',
//             }}>
//                 <div>
//                     <h1 style={{
//                         fontSize: isMobile ? 'clamp(20px, 5vw, 24px)' : 'clamp(24px, 2.5vw, 32px)',
//                         fontWeight: '700',
//                         color: colors.heading,
//                         margin: '0 0 2px 0',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px',
//                         flexWrap: 'wrap',
//                     }}>
//                         <Activity size={isMobile ? 20 : 24} style={{ color: colors.btnBg }} />
//                         Dashboard
//                     </h1>
//                     <p style={{
//                         color: colors.secondaryText,
//                         margin: 0,
//                         fontSize: isMobile ? '12px' : '13px',
//                     }}>
//                         Welcome back, {user?.first_name || user?.username || 'Admin'}
//                     </p>
//                 </div>
//                 <div style={{
//                     display: 'flex',
//                     gap: '6px',
//                     alignItems: 'center',
//                     flexWrap: 'wrap',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         gap: '2px',
//                         padding: '2px',
//                         backgroundColor: colors.raisedBg,
//                         borderRadius: '6px',
//                         border: `1px solid ${colors.border}`,
//                     }}>
//                         {['daily', 'weekly', 'monthly'].map((period) => (
//                             <button
//                                 key={period}
//                                 onClick={() => setSelectedPeriod(period)}
//                                 style={{
//                                     padding: isMobile ? '3px 8px' : '4px 10px',
//                                     borderRadius: '4px',
//                                     border: 'none',
//                                     backgroundColor: selectedPeriod === period ? colors.btnBg : 'transparent',
//                                     color: selectedPeriod === period ? colors.btnText : colors.secondaryText,
//                                     cursor: 'pointer',
//                                     fontSize: isMobile ? '8px' : '10px',
//                                     fontWeight: selectedPeriod === period ? '600' : '500',
//                                     transition: 'all 0.2s',
//                                     textTransform: 'capitalize',
//                                 }}
//                             >
//                                 {period}
//                             </button>
//                         ))}
//                     </div>
//                     <button
//                         onClick={fetchDashboardData}
//                         style={{
//                             padding: isMobile ? '4px 10px' : '6px 12px',
//                             borderRadius: '6px',
//                             border: `1px solid ${colors.border}`,
//                             backgroundColor: colors.raisedBg,
//                             color: colors.text,
//                             cursor: 'pointer',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '3px',
//                             fontSize: isMobile ? '10px' : '12px',
//                             transition: 'all 0.2s',
//                             whiteSpace: 'nowrap',
//                         }}
//                         onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                         onMouseLeave={(e) => e.currentTarget.style.background = colors.raisedBg}
//                     >
//                         <RefreshCw size={isMobile ? 12 : 14} />
//                         {!isMobile && 'Refresh'}
//                     </button>
//                 </div>
//             </div>

//             {/* Stats Grid */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
//                 gap: isMobile ? '8px' : '10px',
//                 marginBottom: isMobile ? '12px' : '20px',
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 <StatCard
//                     icon={<DollarSign size={isMobile ? 16 : 18} />}
//                     label="Revenue"
//                     value={`₵${totalRevenue.toLocaleString()}`}
//                     change="+12.5%"
//                     positive={true}
//                     color={colors.btnBg}
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <StatCard
//                     icon={<ShoppingBag size={isMobile ? 16 : 18} />}
//                     label="Orders"
//                     value={totalOrders}
//                     change={`${pendingOrders} pending`}
//                     positive={true}
//                     color="#3B82F6"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <StatCard
//                     icon={<Users size={isMobile ? 16 : 18} />}
//                     label="Users"
//                     value={totalUsers}
//                     change={`${totalAgents} agents`}
//                     positive={true}
//                     color="#8B5CF6"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <StatCard
//                     icon={<TrendingUp size={isMobile ? 16 : 18} />}
//                     label="Profit"
//                     value={`₵${totalProfit.toLocaleString()}`}
//                     change="+8.2%"
//                     positive={true}
//                     color="#10B981"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//             </div>

//             {/* Quick Stats Row */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
//                 gap: isMobile ? '6px' : '8px',
//                 marginBottom: isMobile ? '12px' : '20px',
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 <QuickStat
//                     label="Today's Orders"
//                     value={todayOrders}
//                     icon={<ShoppingCart size={isMobile ? 14 : 16} />}
//                     color={colors.btnBg}
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <QuickStat
//                     label="Wallet"
//                     value={`₵${walletBalance.toFixed(2)}`}
//                     icon={<Wallet size={isMobile ? 14 : 16} />}
//                     color="#8B5CF6"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <QuickStat
//                     label="Pending"
//                     value={pendingOrders}
//                     icon={<Clock size={isMobile ? 14 : 16} />}
//                     color="#F59E0B"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//                 <QuickStat
//                     label="Sub Agents"
//                     value={totalSubAgents}
//                     icon={<Users size={isMobile ? 14 : 16} />}
//                     color="#3B82F6"
//                     colors={colors}
//                     isMobile={isMobile}
//                 />
//             </div>

//             {/* Registration Fees Section */}
//             <div style={{
//                 backgroundColor: colors.raisedBg,
//                 borderRadius: '12px',
//                 border: `1px solid ${colors.border}`,
//                 padding: isMobile ? '14px 16px' : '18px 22px',
//                 marginBottom: isMobile ? '14px' : '20px',
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: isMobile ? '10px' : '14px',
//                     flexWrap: 'wrap',
//                     gap: '8px',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px',
//                     }}>
//                         <Coins size={isMobile ? 18 : 20} style={{ color: colors.btnBg }} />
//                         <span style={{
//                             fontWeight: '600',
//                             fontSize: isMobile ? '14px' : '16px',
//                             color: colors.heading,
//                         }}>
//                             Registration Fees
//                         </span>
//                         {registrationFees?.updated_by_username && (
//                             <span style={{
//                                 fontSize: isMobile ? '9px' : '11px',
//                                 color: colors.secondaryText,
//                                 opacity: 0.6,
//                             }}>
//                                 Updated by {registrationFees.updated_by_username}
//                             </span>
//                         )}
//                     </div>
//                     {!isEditingFees ? (
//                         <button
//                             onClick={handleEditFees}
//                             style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '4px',
//                                 padding: isMobile ? '4px 10px' : '6px 14px',
//                                 borderRadius: '8px',
//                                 border: `1px solid ${colors.border}`,
//                                 backgroundColor: 'transparent',
//                                 color: colors.secondaryText,
//                                 cursor: 'pointer',
//                                 fontSize: isMobile ? '11px' : '12px',
//                                 transition: 'all 0.2s',
//                             }}
//                             onMouseEnter={(e) => {
//                                 e.currentTarget.style.background = colors.hoverBg;
//                                 e.currentTarget.style.color = colors.heading;
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.currentTarget.style.background = 'transparent';
//                                 e.currentTarget.style.color = colors.secondaryText;
//                             }}
//                         >
//                             <Edit2 size={isMobile ? 14 : 16} />
//                             Edit
//                         </button>
//                     ) : (
//                         <div style={{
//                             display: 'flex',
//                             gap: '6px',
//                         }}>
//                             <button
//                                 onClick={handleCancelEditFees}
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '4px',
//                                     padding: isMobile ? '4px 10px' : '6px 14px',
//                                     borderRadius: '8px',
//                                     border: `1px solid ${colors.border}`,
//                                     backgroundColor: 'transparent',
//                                     color: colors.secondaryText,
//                                     cursor: 'pointer',
//                                     fontSize: isMobile ? '11px' : '12px',
//                                     transition: 'all 0.2s',
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.background = colors.hoverBg;
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.background = 'transparent';
//                                 }}
//                             >
//                                 <X size={isMobile ? 14 : 16} />
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleSaveFees}
//                                 disabled={isSavingFees}
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '4px',
//                                     padding: isMobile ? '4px 10px' : '6px 14px',
//                                     borderRadius: '8px',
//                                     border: 'none',
//                                     backgroundColor: colors.btnBg,
//                                     color: colors.btnText,
//                                     cursor: isSavingFees ? 'not-allowed' : 'pointer',
//                                     fontSize: isMobile ? '11px' : '12px',
//                                     fontWeight: '600',
//                                     opacity: isSavingFees ? 0.7 : 1,
//                                     transition: 'all 0.2s',
//                                 }}
//                             >
//                                 {isSavingFees ? (
//                                     <>
//                                         <div className="spinner-small" style={{
//                                             width: '14px',
//                                             height: '14px',
//                                             border: `2px solid ${colors.btnText}40`,
//                                             borderTop: `2px solid ${colors.btnText}`,
//                                             borderRadius: '50%',
//                                             animation: 'spin 0.8s linear infinite',
//                                         }} />
//                                         Saving...
//                                     </>
//                                 ) : (
//                                     <>
//                                         <Save size={isMobile ? 14 : 16} />
//                                         Save
//                                     </>
//                                 )}
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                     gap: isMobile ? '10px' : '16px',
//                 }}>
//                     <div>
//                         <div style={{
//                             fontSize: isMobile ? '11px' : '12px',
//                             color: colors.secondaryText,
//                             marginBottom: '4px',
//                             fontWeight: '500',
//                         }}>
//                             Agent Registration Fee
//                         </div>
//                         {isEditingFees ? (
//                             <div style={{
//                                 position: 'relative',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                             }}>
//                                 <span style={{
//                                     position: 'absolute',
//                                     left: '12px',
//                                     color: colors.secondaryText,
//                                     fontWeight: '600',
//                                     fontSize: isMobile ? '14px' : '16px',
//                                 }}>
//                                     ₵
//                                 </span>
//                                 <input
//                                     type="text"
//                                     name="agent_registration_fee"
//                                     value={editFeesData.agent_registration_fee}
//                                     onChange={handleFeeInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: isMobile ? '8px 12px 8px 32px' : '10px 14px 10px 36px',
//                                         borderRadius: '8px',
//                                         border: `1.5px solid ${colors.btnBg}`,
//                                         backgroundColor: colors.raisedBg,
//                                         color: colors.text,
//                                         fontSize: isMobile ? '14px' : '16px',
//                                         outline: 'none',
//                                         fontWeight: '600',
//                                     }}
//                                     autoFocus
//                                 />
//                             </div>
//                         ) : (
//                             <div style={{
//                                 fontSize: isMobile ? '20px' : '24px',
//                                 fontWeight: '700',
//                                 color: colors.btnBg,
//                             }}>
//                                 ₵{registrationFees?.agent_registration_fee || '0.00'}
//                             </div>
//                         )}
//                     </div>
//                     <div>
//                         <div style={{
//                             fontSize: isMobile ? '11px' : '12px',
//                             color: colors.secondaryText,
//                             marginBottom: '4px',
//                             fontWeight: '500',
//                         }}>
//                             Sub-Agent Registration Fee
//                         </div>
//                         {isEditingFees ? (
//                             <div style={{
//                                 position: 'relative',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                             }}>
//                                 <span style={{
//                                     position: 'absolute',
//                                     left: '12px',
//                                     color: colors.secondaryText,
//                                     fontWeight: '600',
//                                     fontSize: isMobile ? '14px' : '16px',
//                                 }}>
//                                     ₵
//                                 </span>
//                                 <input
//                                     type="text"
//                                     name="sub_agent_registration_fee"
//                                     value={editFeesData.sub_agent_registration_fee}
//                                     onChange={handleFeeInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: isMobile ? '8px 12px 8px 32px' : '10px 14px 10px 36px',
//                                         borderRadius: '8px',
//                                         border: `1.5px solid ${colors.btnBg}`,
//                                         backgroundColor: colors.raisedBg,
//                                         color: colors.text,
//                                         fontSize: isMobile ? '14px' : '16px',
//                                         outline: 'none',
//                                         fontWeight: '600',
//                                     }}
//                                 />
//                             </div>
//                         ) : (
//                             <div style={{
//                                 fontSize: isMobile ? '20px' : '24px',
//                                 fontWeight: '700',
//                                 color: '#8B5CF6',
//                             }}>
//                                 ₵{registrationFees?.sub_agent_registration_fee || '0.00'}
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {registrationFees?.updated_at && !isEditingFees && (
//                     <div style={{
//                         fontSize: isMobile ? '9px' : '10px',
//                         color: colors.secondaryText,
//                         opacity: 0.5,
//                         marginTop: isMobile ? '8px' : '10px',
//                         paddingTop: isMobile ? '8px' : '10px',
//                         borderTop: `1px solid ${colors.border}`,
//                     }}>
//                         Last updated: {formatDate(registrationFees.updated_at)}
//                     </div>
//                 )}
//             </div>

//             {/* Chart Section */}
//             <div style={{
//                 backgroundColor: colors.raisedBg,
//                 borderRadius: '12px',
//                 border: `1px solid ${colors.border}`,
//                 padding: isMobile ? '12px 14px' : '16px 18px',
//                 marginBottom: isMobile ? '12px' : '20px',
//                 boxShadow: `0 2px 8px ${colors.shadow}`,
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: isMobile ? '8px' : '12px',
//                     flexWrap: 'wrap',
//                     gap: '6px',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                     }}>
//                         <BarChart3 size={isMobile ? 16 : 18} style={{ color: colors.btnBg }} />
//                         <span style={{
//                             fontWeight: '600',
//                             fontSize: isMobile ? '13px' : '15px',
//                             color: colors.heading,
//                         }}>
//                             Analytics
//                         </span>
//                     </div>
//                     {chartData?.summary && (
//                         <div style={{
//                             display: 'flex',
//                             gap: isMobile ? '6px' : '12px',
//                             fontSize: isMobile ? '9px' : '11px',
//                             color: colors.secondaryText,
//                             flexWrap: 'wrap',
//                         }}>
//                             <span>Orders: <strong style={{ color: colors.text }}>{chartData.summary.total_orders || 0}</strong></span>
//                             <span>Revenue: <strong style={{ color: colors.text }}>₵{(chartData.summary.total_revenue || 0).toFixed(2)}</strong></span>
//                             {!isMobile && (
//                                 <span>Users: <strong style={{ color: colors.text }}>{chartData.summary.total_new_users || 0}</strong></span>
//                             )}
//                         </div>
//                     )}
//                 </div>
//                 <div style={{
//                     width: '100%',
//                     minHeight: isMobile ? '160px' : '220px',
//                 }}>
//                     {renderChart()}
//                 </div>
//             </div>

//             {/* Two Column Layout - Fixed Responsive */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                 gap: isMobile ? '12px' : '16px',
//                 marginBottom: isMobile ? '12px' : '20px',
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 {/* Recent Orders */}
//                 <div style={{
//                     backgroundColor: colors.raisedBg,
//                     borderRadius: '12px',
//                     border: `1px solid ${colors.border}`,
//                     overflow: 'hidden',
//                     width: '100%',
//                     boxSizing: 'border-box',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: isMobile ? '10px 12px' : '14px 16px',
//                         borderBottom: `1px solid ${colors.border}`,
//                         flexWrap: 'wrap',
//                         gap: '6px',
//                     }}>
//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '6px',
//                         }}>
//                             <ShoppingBag size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
//                             <span style={{
//                                 fontWeight: '600',
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 color: colors.heading,
//                             }}>
//                                 Recent Orders
//                             </span>
//                         </div>
//                         <button
//                             onClick={() => navigate('/orders')}
//                             style={{
//                                 fontSize: isMobile ? '11px' : '12px',
//                                 color: colors.btnBg,
//                                 background: 'none',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '2px',
//                                 fontWeight: '500',
//                             }}
//                         >
//                             View All <ChevronRight size={isMobile ? 12 : 14} />
//                         </button>
//                     </div>
//                     <div style={{
//                         overflowX: 'auto',
//                         WebkitOverflowScrolling: 'touch',
//                         width: '100%',
//                     }}>
//                         {recentOrders && recentOrders.length > 0 ? (
//                             recentOrders.map((order) => (
//                                 <div
//                                     key={order.id}
//                                     style={{
//                                         display: 'grid',
//                                         gridTemplateColumns: isMobile ? '0.7fr 1fr 0.6fr 0.6fr' : '0.8fr 1fr 0.7fr 0.7fr',
//                                         padding: isMobile ? '8px 12px' : '10px 16px',
//                                         borderBottom: `1px solid ${colors.border}`,
//                                         alignItems: 'center',
//                                         fontSize: isMobile ? '11px' : '12px',
//                                         transition: 'background 0.2s',
//                                         gap: isMobile ? '3px' : '4px',
//                                         minWidth: isMobile ? '280px' : 'auto',
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                                     onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 >
//                                     <span style={{
//                                         fontWeight: '500',
//                                         color: colors.heading,
//                                         fontSize: isMobile ? '10px' : '11px',
//                                     }}>
//                                         {order.id?.slice(0, 8) || 'N/A'}
//                                     </span>
//                                     <span style={{
//                                         color: colors.text,
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         whiteSpace: 'nowrap',
//                                         fontSize: isMobile ? '10px' : '12px',
//                                     }}>
//                                         {order.customer?.username || order.customer_username || 'N/A'}
//                                     </span>
//                                     <span style={{
//                                         fontWeight: '600',
//                                         color: colors.btnBg,
//                                         fontSize: isMobile ? '11px' : '12px',
//                                     }}>
//                                         ₵{order.customer_price || '0.00'}
//                                     </span>
//                                     <span style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '2px',
//                                         color: getStatusColor(order.status),
//                                         fontSize: isMobile ? '9px' : '10px',
//                                         fontWeight: '600',
//                                         textTransform: 'capitalize',
//                                     }}>
//                                         {getStatusIcon(order.status)}
//                                         {isMobile ? getStatusLabel(order.status).slice(0, 3) : getStatusLabel(order.status)}
//                                     </span>
//                                 </div>
//                             ))
//                         ) : (
//                             <div style={{
//                                 padding: isMobile ? '20px 12px' : '30px 16px',
//                                 textAlign: 'center',
//                                 color: colors.secondaryText,
//                                 fontSize: isMobile ? '12px' : '13px',
//                             }}>
//                                 No recent orders
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Recent Users */}
//                 <div style={{
//                     backgroundColor: colors.raisedBg,
//                     borderRadius: '12px',
//                     border: `1px solid ${colors.border}`,
//                     overflow: 'hidden',
//                     width: '100%',
//                     boxSizing: 'border-box',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         padding: isMobile ? '10px 12px' : '14px 16px',
//                         borderBottom: `1px solid ${colors.border}`,
//                         flexWrap: 'wrap',
//                         gap: '6px',
//                     }}>
//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '6px',
//                         }}>
//                             <Users size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
//                             <span style={{
//                                 fontWeight: '600',
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 color: colors.heading,
//                             }}>
//                                 New Users
//                             </span>
//                         </div>
//                         <button
//                             onClick={() => navigate('/admin/users')}
//                             style={{
//                                 fontSize: isMobile ? '11px' : '12px',
//                                 color: colors.btnBg,
//                                 background: 'none',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '2px',
//                                 fontWeight: '500',
//                             }}
//                         >
//                             View All <ChevronRight size={isMobile ? 12 : 14} />
//                         </button>
//                     </div>
//                     <div>
//                         {recentUsers && recentUsers.length > 0 ? (
//                             recentUsers.map((user) => (
//                                 <div
//                                     key={user.id}
//                                     style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'space-between',
//                                         padding: isMobile ? '6px 12px' : '8px 16px',
//                                         borderBottom: `1px solid ${colors.border}`,
//                                         transition: 'background 0.2s',
//                                         gap: '6px',
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.background = colors.hoverBg}
//                                     onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 >
//                                     <div style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '6px',
//                                         minWidth: 0,
//                                         flex: 1,
//                                     }}>
//                                         <div style={{
//                                             width: isMobile ? '24px' : '28px',
//                                             height: isMobile ? '24px' : '28px',
//                                             borderRadius: '50%',
//                                             backgroundColor: `${getRoleBadgeColor(user.role)}20`,
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             color: getRoleBadgeColor(user.role),
//                                             fontSize: isMobile ? '10px' : '12px',
//                                             fontWeight: '600',
//                                             flexShrink: 0,
//                                         }}>
//                                             {user.first_name?.[0] || user.username?.[0] || 'U'}
//                                         </div>
//                                         <div style={{ minWidth: 0, flex: 1 }}>
//                                             <div style={{
//                                                 fontSize: isMobile ? '11px' : '12px',
//                                                 fontWeight: '500',
//                                                 color: colors.heading,
//                                                 overflow: 'hidden',
//                                                 textOverflow: 'ellipsis',
//                                                 whiteSpace: 'nowrap',
//                                             }}>
//                                                 {user.first_name || user.username}
//                                                 {user.last_name && ` ${user.last_name}`}
//                                             </div>
//                                             <div style={{
//                                                 fontSize: isMobile ? '9px' : '10px',
//                                                 color: colors.secondaryText,
//                                                 overflow: 'hidden',
//                                                 textOverflow: 'ellipsis',
//                                                 whiteSpace: 'nowrap',
//                                             }}>
//                                                 {user.email}
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <span style={{
//                                         fontSize: isMobile ? '8px' : '9px',
//                                         padding: isMobile ? '1px 6px' : '1px 8px',
//                                         borderRadius: '8px',
//                                         backgroundColor: `${getRoleBadgeColor(user.role)}20`,
//                                         color: getRoleBadgeColor(user.role),
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         flexShrink: 0,
//                                         whiteSpace: 'nowrap',
//                                     }}>
//                                         {isMobile ? getRoleLabel(user.role).slice(0, 4) : getRoleLabel(user.role)}
//                                     </span>
//                                 </div>
//                             ))
//                         ) : (
//                             <div style={{
//                                 padding: isMobile ? '20px 12px' : '30px 16px',
//                                 textAlign: 'center',
//                                 color: colors.secondaryText,
//                                 fontSize: isMobile ? '12px' : '13px',
//                             }}>
//                                 No recent users
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Top Packages */}
//             <div style={{
//                 backgroundColor: colors.raisedBg,
//                 borderRadius: '12px',
//                 border: `1px solid ${colors.border}`,
//                 overflow: 'hidden',
//                 width: '100%',
//                 boxSizing: 'border-box',
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     padding: isMobile ? '10px 12px' : '14px 16px',
//                     borderBottom: `1px solid ${colors.border}`,
//                     flexWrap: 'wrap',
//                     gap: '6px',
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                     }}>
//                         <Award size={isMobile ? 14 : 16} style={{ color: colors.btnBg }} />
//                         <span style={{
//                             fontWeight: '600',
//                             fontSize: isMobile ? '13px' : '14px',
//                             color: colors.heading,
//                         }}>
//                             Top Packages
//                         </span>
//                     </div>
//                     <span style={{
//                         fontSize: isMobile ? '9px' : '11px',
//                         color: colors.secondaryText,
//                     }}>
//                         By sales volume
//                     </span>
//                 </div>
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(170px, 1fr))',
//                     gap: isMobile ? '6px' : '10px',
//                     padding: isMobile ? '10px 12px' : '14px 16px',
//                     width: '100%',
//                     boxSizing: 'border-box',
//                 }}>
//                     {topPackages && topPackages.length > 0 ? (
//                         topPackages.map((pkg, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     padding: isMobile ? '8px 10px' : '12px 14px',
//                                     backgroundColor: colors.mainBg,
//                                     borderRadius: '8px',
//                                     border: `1px solid ${colors.border}`,
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     transition: 'all 0.3s ease',
//                                     width: '100%',
//                                     boxSizing: 'border-box',
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(-2px)';
//                                     e.currentTarget.style.boxShadow = `0 4px 12px ${colors.shadow}`;
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(0)';
//                                     e.currentTarget.style.boxShadow = 'none';
//                                 }}
//                             >
//                                 <div>
//                                     <div style={{
//                                         fontSize: isMobile ? '10px' : '12px',
//                                         fontWeight: '600',
//                                         color: colors.heading,
//                                         textTransform: 'uppercase',
//                                     }}>
//                                         {pkg.network}
//                                     </div>
//                                     <div style={{
//                                         fontSize: isMobile ? '9px' : '11px',
//                                         color: colors.secondaryText,
//                                     }}>
//                                         {pkg.size_gb}GB • {pkg.sales_count || 0} sales
//                                     </div>
//                                 </div>
//                                 <div style={{
//                                     fontSize: isMobile ? '12px' : '14px',
//                                     fontWeight: '700',
//                                     color: colors.btnBg,
//                                 }}>
//                                     ₵{parseFloat(pkg.total_revenue || 0).toFixed(2)}
//                                 </div>
//                             </div>
//                         ))
//                     ) : (
//                         <div style={{
//                             padding: isMobile ? '20px 12px' : '30px 16px',
//                             textAlign: 'center',
//                             color: colors.secondaryText,
//                             gridColumn: '1 / -1',
//                             fontSize: isMobile ? '12px' : '13px',
//                         }}>
//                             No package data available
//                         </div>
//                     )}
//                 </div>
//             </div>

//             <style>{`
//                 @keyframes spin {
//                     0% { transform: rotate(0deg); }
//                     100% { transform: rotate(360deg); }
//                 }

//                 @keyframes slideUp {
//                     from {
//                         opacity: 0;
//                         transform: translateY(20px);
//                     }
//                     to {
//                         opacity: 1;
//                         transform: translateY(0);
//                     }
//                 }

//                 * {
//                     box-sizing: border-box;
//                 }

//                 @media (max-width: 768px) {
//                     .two-column-grid {
//                         grid-template-columns: 1fr !important;
//                     }
//                 }

//                 @media (max-width: 480px) {
//                     .stat-card {
//                         padding: 8px 10px !important;
//                     }
                    
//                     .stat-value {
//                         font-size: 14px !important;
//                     }
                    
//                     .stat-label {
//                         font-size: 9px !important;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // Stat Card Component - Fixed width and alignment
// const StatCard = ({ icon, label, value, change, positive, color, colors, isMobile }) => (
//     <div style={{
//         backgroundColor: colors.raisedBg,
//         borderRadius: isMobile ? '10px' : '12px',
//         padding: isMobile ? '10px 12px' : '14px 16px',
//         border: `1px solid ${colors.border}`,
//         transition: 'all 0.3s ease',
//         width: '100%',
//         boxSizing: 'border-box',
//         display: 'flex',
//         flexDirection: 'column',
//     }}
//     onMouseEnter={(e) => {
//         e.currentTarget.style.transform = 'translateY(-3px)';
//         e.currentTarget.style.boxShadow = `0 6px 20px ${colors.shadow}`;
//     }}
//     onMouseLeave={(e) => {
//         e.currentTarget.style.transform = 'translateY(0)';
//         e.currentTarget.style.boxShadow = 'none';
//     }}>
//         <div style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             marginBottom: isMobile ? '2px' : '4px',
//             width: '100%',
//         }}>
//             <span style={{
//                 fontSize: isMobile ? '9px' : '11px',
//                 color: colors.secondaryText,
//                 fontWeight: '500',
//                 whiteSpace: 'nowrap',
//             }}>
//                 {label}
//             </span>
//             <span style={{
//                 color: color,
//                 opacity: 0.7,
//                 display: 'flex',
//                 alignItems: 'center',
//                 flexShrink: 0,
//             }}>
//                 {icon}
//             </span>
//         </div>
//         <div style={{
//             fontSize: isMobile ? 'clamp(16px, 4vw, 20px)' : 'clamp(18px, 2vw, 22px)',
//             fontWeight: '700',
//             color: colors.heading,
//             width: '100%',
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//             whiteSpace: 'nowrap',
//         }}>
//             {value}
//         </div>
//         {change && (
//             <div style={{
//                 fontSize: isMobile ? '9px' : '11px',
//                 color: positive ? '#10B981' : '#EF4444',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '2px',
//                 marginTop: isMobile ? '1px' : '2px',
//             }}>
//                 {positive ? <ArrowUp size={isMobile ? 10 : 12} /> : <ArrowDown size={isMobile ? 10 : 12} />}
//                 {change}
//             </div>
//         )}
//     </div>
// );

// // Quick Stat Component - Fixed width and alignment
// const QuickStat = ({ label, value, icon, color, colors, isMobile }) => (
//     <div style={{
//         backgroundColor: colors.raisedBg,
//         borderRadius: isMobile ? '8px' : '10px',
//         padding: isMobile ? '8px 10px' : '10px 14px',
//         border: `1px solid ${colors.border}`,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         width: '100%',
//         boxSizing: 'border-box',
//     }}>
//         <div style={{ minWidth: 0, flex: 1 }}>
//             <div style={{
//                 fontSize: isMobile ? '8px' : '10px',
//                 color: colors.secondaryText,
//                 fontWeight: '500',
//                 whiteSpace: 'nowrap',
//             }}>
//                 {label}
//             </div>
//             <div style={{
//                 fontSize: isMobile ? 'clamp(14px, 3.5vw, 18px)' : '16px',
//                 fontWeight: '700',
//                 color: colors.heading,
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis',
//                 whiteSpace: 'nowrap',
//             }}>
//                 {value}
//             </div>
//         </div>
//         <span style={{
//             color: color,
//             opacity: 0.6,
//             display: 'flex',
//             alignItems: 'center',
//             flexShrink: 0,
//             marginLeft: '8px',
//         }}>
//             {icon}
//         </span>
//     </div>
// );

// export default AdminDashboard;





























// screens/admin/AdminDashboard.jsx
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTheme } from "../../hooks/useTheme";
import { useAuth } from "../../providers/AuthProvider";
import { useToast } from "../../providers/ToastProvider";
import { useNavigate } from "react-router-dom";
import {
  Users,
  ShoppingBag,
  TrendingUp,
  DollarSign,
  Wallet,
  BarChart3,
  Clock,
  CheckCircle,
  AlertCircle,
  ChevronRight,
  RefreshCw,
  ArrowUp,
  ArrowDown,
  ShoppingCart,
  Activity,
  Award,
  Edit2,
  Save,
  X,
  Coins,
  Package,
} from "lucide-react";

/* ══════════════════════════════════════════════════════════
   Module constants — allocated once
   ══════════════════════════════════════════════════════════ */

const STATUS_COLORS = {
  COMPLETED: "#10B981",
  PROCESSING: "#3B82F6",
  PENDING: "#F59E0B",
  FAILED: "#EF4444",
  CANCELLED: "#6B7280",
};

const ROLE_COLORS = {
  ADMIN: "#EF4444",
  AGENT: "#3B82F6",
  SUB_AGENT: "#8B5CF6",
  CUSTOMER: "#10B981",
};

const ROLE_LABELS = {
  ADMIN: "Admin",
  AGENT: "Agent",
  SUB_AGENT: "Sub Agent",
  CUSTOMER: "Customer",
};

const CHART_TABS = ["revenue", "profit", "orders", "users"];
const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const getStatusColor = (s) => STATUS_COLORS[s] || "#6B7280";
const getStatusLabel = (s) =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "N/A";
const getRoleColor = (r) => ROLE_COLORS[r] || "#6B7280";
const getRoleLabel = (r) => ROLE_LABELS[r] || r || "—";

const StatusIcon = memo(({ status, size = 14 }) => {
  const map = {
    COMPLETED: CheckCircle,
    PROCESSING: RefreshCw,
    PENDING: Clock,
    FAILED: AlertCircle,
    CANCELLED: AlertCircle,
  };
  const Icon = map[status];
  return Icon ? <Icon size={size} /> : null;
});

const formatDate = (iso) => {
  if (!iso) return "N/A";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "N/A";
  }
};

/* ══════════════════════════════════════════════════════════
   Static styles — injected once
   ══════════════════════════════════════════════════════════ */

const STATIC_CSS = `
  @keyframes ad-spin { to { transform: rotate(360deg); } }
  @keyframes ad-fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes ad-barGrow { from { transform: scaleY(0); } to { transform: scaleY(1); } }
`;

const useStaticStyles = () => {
  useEffect(() => {
    const id = "admin-dashboard-static";
    if (document.getElementById(id)) return;
    const tag = document.createElement("style");
    tag.id = id;
    tag.innerHTML = STATIC_CSS;
    document.head.appendChild(tag);
  }, []);
};

/* ══════════════════════════════════════════════════════════
   Dashboard
   ══════════════════════════════════════════════════════════ */

const AdminDashboard = () => {
  const { colors } = useTheme();
  const { user, authFetch } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  useStaticStyles();

  /* ── View state ──────────────────────────────────── */
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  /* ── Data state ──────────────────────────────────── */
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const [stats, setStats] = useState(null);
  const [walletBalance, setWalletBalance] = useState(0);
  const [recentOrders, setRecentOrders] = useState([]);
  const [recentUsers, setRecentUsers] = useState([]);
  const [topPackages, setTopPackages] = useState([]);
  const [registrationFees, setRegistrationFees] = useState(null);
  const [activeChartTab, setActiveChartTab] = useState("revenue");

  /* ── Fees editing state ──────────────────────────── */
  const [isEditingFees, setIsEditingFees] = useState(false);
  const [editFeesData, setEditFeesData] = useState({
    agent_registration_fee: "",
    sub_agent_registration_fee: "",
  });
  const [isSavingFees, setIsSavingFees] = useState(false);

  /* ── Abort controller ─────────────────────────────── */
  const abortRef = useRef(null);

  /* ── Responsive listener ──────────────────────────── */
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* ── Parallel fetch ───────────────────────────────── */
  const fetchDashboardData = useCallback(
    async ({ silent } = {}) => {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;

      if (silent) setRefreshing(true);
      else setLoading(true);

      const safeFetch = async (url, key) => {
        try {
          const res = await authFetch(url, { signal: controller.signal });
          const data = await res.json();
          return res.ok && data.status === "success"
            ? { key, ok: true, data: data.data }
            : { key, ok: false };
        } catch (err) {
          if (err.name === "AbortError") throw err;
          return { key, ok: false };
        }
      };

      try {
        const results = await Promise.all([
          safeFetch("/accounts/dashboard/stats/", "stats"),
          safeFetch(
            "/data/orders/?page_size=5&ordering=-created_at",
            "orders"
          ),
          safeFetch(
            "/accounts/users/?page_size=5&ordering=-date_joined",
            "users"
          ),
          safeFetch("/data/packages/?is_active=true", "packages"),
          safeFetch("/accounts/registration-fees/", "fees"),
        ]);

        // If the whole batch was aborted, bail silently.
        if (controller.signal.aborted) return;

        for (const r of results) {
          if (!r.ok) continue;
          switch (r.key) {
            case "stats":
              setStats(r.data);
              setWalletBalance(parseFloat(r.data.wallet_balance || 0));
              break;
            case "orders":
              setRecentOrders(r.data || []);
              break;
            case "users":
              setRecentUsers(r.data || []);
              break;
            case "packages": {
              const sorted = (r.data || [])
                .filter((p) => p.sales_count > 0)
                .sort(
                  (a, b) => (b.sales_count || 0) - (a.sales_count || 0)
                )
                .slice(0, 4);
              setTopPackages(sorted);
              break;
            }
            case "fees":
              setRegistrationFees(r.data);
              setEditFeesData({
                agent_registration_fee: r.data.agent_registration_fee || "",
                sub_agent_registration_fee:
                  r.data.sub_agent_registration_fee || "",
              });
              break;
            default:
              break;
          }
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        showToast("Failed to load dashboard data", "error");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [authFetch, showToast]
  );

  useEffect(() => {
    fetchDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ── Derived data (memoised) ──────────────────────── */
  const adminStats = useMemo(() => stats?.admin || {}, [stats]);

  const parsedStats = useMemo(
    () => ({
      totalRevenue: parseFloat(adminStats.total_revenue || 0),
      totalOrders: adminStats.total_transactions || 0,
      totalUsers: adminStats.total_users || 0,
      totalProfit: parseFloat(adminStats.total_profit || 0),
      pendingOrders: adminStats.pending_orders || 0,
      todayOrders: adminStats.today_orders || 0,
      totalAgents: adminStats.total_agents || 0,
      totalSubAgents: adminStats.total_sub_agents || 0,
      totalCustomers: adminStats.total_customers || 0,
    }),
    [adminStats]
  );

  /* Chart data — previously derived in a useEffect, now memoised */
  const chartData = useMemo(() => {
    const weekly = adminStats.weekly;
    if (!weekly) return null;

    const pick = (arr, day) => {
      const found = arr?.find((r) => r.day === day);
      return found ? found.value : 0;
    };
    const revenue = DAY_LABELS.map((d) => pick(weekly.revenue, d));
    const profit = DAY_LABELS.map((d) => pick(weekly.profit, d));
    const orders = DAY_LABELS.map((d) => pick(weekly.orders, d));
    const users = DAY_LABELS.map((d) => pick(weekly.new_users, d));

    return {
      labels: DAY_LABELS,
      revenue,
      profit,
      orders,
      users,
      summary: weekly.summary || {},
    };
  }, [adminStats]);

  /* ── Fees handlers ───────────────────────────────── */
  const handleEditFees = useCallback(() => {
    setIsEditingFees(true);
    setEditFeesData({
      agent_registration_fee: registrationFees?.agent_registration_fee || "",
      sub_agent_registration_fee:
        registrationFees?.sub_agent_registration_fee || "",
    });
  }, [registrationFees]);

  const handleCancelEditFees = useCallback(() => {
    setIsEditingFees(false);
    setEditFeesData({
      agent_registration_fee: registrationFees?.agent_registration_fee || "",
      sub_agent_registration_fee:
        registrationFees?.sub_agent_registration_fee || "",
    });
  }, [registrationFees]);

  const handleSaveFees = useCallback(async () => {
    const agentFee = parseFloat(editFeesData.agent_registration_fee);
    const subAgentFee = parseFloat(editFeesData.sub_agent_registration_fee);
    if (isNaN(agentFee) || agentFee < 0) {
      showToast("Agent fee must be a valid positive number", "error");
      return;
    }
    if (isNaN(subAgentFee) || subAgentFee < 0) {
      showToast("Sub-agent fee must be a valid positive number", "error");
      return;
    }
    setIsSavingFees(true);
    try {
      const res = await authFetch("/accounts/registration-fees/", {
        method: "PUT",
        body: JSON.stringify({
          agent_registration_fee: agentFee.toFixed(2),
          sub_agent_registration_fee: subAgentFee.toFixed(2),
        }),
      });
      const data = await res.json();
      if (res.ok && data.status === "success") {
        showToast("Registration fees updated", "success");
        setRegistrationFees(data.data);
        setIsEditingFees(false);
      } else {
        showToast(data.message || "Failed to update fees", "error");
      }
    } catch {
      showToast("Network error. Please try again.", "error");
    } finally {
      setIsSavingFees(false);
    }
  }, [authFetch, editFeesData, showToast]);

  const handleFeeInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const cleaned = value.replace(/[^0-9.]/g, "");
    setEditFeesData((prev) => ({ ...prev, [name]: cleaned }));
  }, []);

  /* ── Loading ──────────────────────────────────────── */
  if (loading) {
    return (
      <div style={styles.pageWrap}>
        <div style={styles.loadingBox(colors)}>
          <div style={styles.spinner(colors)} />
          <span style={{ color: colors.secondaryText, fontSize: 13 }}>
            Loading dashboard…
          </span>
        </div>
      </div>
    );
  }

  /* ══════════════════════════════════════════════════
     Render
     ══════════════════════════════════════════════════ */
  return (
    <div style={styles.pageWrap}>
      {/* ── Header ─────────────────────────────────── */}
      <header style={styles.header}>
        <div style={{ minWidth: 0 }}>
          <h1 style={styles.h1(colors, isMobile)}>
            <Activity size={isMobile ? 20 : 24} color={colors.btnBg} />
            Dashboard
          </h1>
          <p style={styles.subtitle(colors, isMobile)}>
            Welcome back, {user?.first_name || user?.username || "Admin"}
          </p>
        </div>
        <div style={styles.headerActions}>
          <button
            type="button"
            onClick={() => fetchDashboardData({ silent: true })}
            disabled={refreshing}
            style={styles.ghostBtn(colors, refreshing)}
          >
            <RefreshCw
              size={14}
              style={{
                animation: refreshing ? "ad-spin 0.8s linear infinite" : "none",
              }}
            />
            {!isMobile && (refreshing ? "Refreshing…" : "Refresh")}
          </button>
        </div>
      </header>

      {/* ── Primary stats ──────────────────────────── */}
      <div style={styles.statsGrid(isMobile)}>
        <StatCard
          icon={<DollarSign size={isMobile ? 16 : 18} />}
          label="Revenue"
          value={`₵${parsedStats.totalRevenue.toLocaleString()}`}
          change="+12.5%"
          positive
          color={colors.btnBg}
          colors={colors}
          isMobile={isMobile}
        />
        <StatCard
          icon={<ShoppingBag size={isMobile ? 16 : 18} />}
          label="Orders"
          value={parsedStats.totalOrders}
          change={`${parsedStats.pendingOrders} pending`}
          positive
          color="#3B82F6"
          colors={colors}
          isMobile={isMobile}
        />
        <StatCard
          icon={<Users size={isMobile ? 16 : 18} />}
          label="Users"
          value={parsedStats.totalUsers}
          change={`${parsedStats.totalAgents} agents`}
          positive
          color="#8B5CF6"
          colors={colors}
          isMobile={isMobile}
        />
        <StatCard
          icon={<TrendingUp size={isMobile ? 16 : 18} />}
          label="Profit"
          value={`₵${parsedStats.totalProfit.toLocaleString()}`}
          change="+8.2%"
          positive
          color="#10B981"
          colors={colors}
          isMobile={isMobile}
        />
      </div>

      {/* ── Quick stats ────────────────────────────── */}
      <div style={styles.quickGrid(isMobile)}>
        <QuickStat
          label="Today's Orders"
          value={parsedStats.todayOrders}
          icon={<ShoppingCart size={isMobile ? 14 : 16} />}
          color={colors.btnBg}
          colors={colors}
          isMobile={isMobile}
        />
        <QuickStat
          label="Wallet"
          value={`₵${walletBalance.toFixed(2)}`}
          icon={<Wallet size={isMobile ? 14 : 16} />}
          color="#8B5CF6"
          colors={colors}
          isMobile={isMobile}
        />
        <QuickStat
          label="Pending"
          value={parsedStats.pendingOrders}
          icon={<Clock size={isMobile ? 14 : 16} />}
          color="#F59E0B"
          colors={colors}
          isMobile={isMobile}
        />
        <QuickStat
          label="Sub Agents"
          value={parsedStats.totalSubAgents}
          icon={<Users size={isMobile ? 14 : 16} />}
          color="#3B82F6"
          colors={colors}
          isMobile={isMobile}
        />
      </div>

      {/* ── Registration fees ──────────────────────── */}
      <RegistrationFeesCard
        colors={colors}
        isMobile={isMobile}
        fees={registrationFees}
        isEditing={isEditingFees}
        isSaving={isSavingFees}
        editData={editFeesData}
        onChange={handleFeeInputChange}
        onEdit={handleEditFees}
        onCancel={handleCancelEditFees}
        onSave={handleSaveFees}
      />

      {/* ── Chart ──────────────────────────────────── */}
      {chartData && (
        <ChartCard
          colors={colors}
          isMobile={isMobile}
          chartData={chartData}
          activeTab={activeChartTab}
          setActiveTab={setActiveChartTab}
        />
      )}

      {/* ── Recent orders + users ─────────────────── */}
      <div style={styles.twoCol(isMobile)}>
        <RecentOrdersCard
          colors={colors}
          isMobile={isMobile}
          orders={recentOrders}
          onViewAll={() => navigate("/orders")}
        />
        <RecentUsersCard
          colors={colors}
          isMobile={isMobile}
          users={recentUsers}
          onViewAll={() => navigate("/admin/users")}
        />
      </div>

      {/* ── Top packages ───────────────────────────── */}
      <TopPackagesCard
        colors={colors}
        isMobile={isMobile}
        packages={topPackages}
      />
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   Stat card
   ══════════════════════════════════════════════════════════ */

const StatCard = memo(function StatCard({
  icon,
  label,
  value,
  change,
  positive,
  color,
  colors,
  isMobile,
}) {
  return (
    <div
      style={styles.statCard(colors, isMobile)}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 6px 20px ${colors.shadow}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={styles.statTop}>
        <span style={styles.statLabel(colors, isMobile)}>{label}</span>
        <span style={{ color, opacity: 0.7, display: "inline-flex" }}>
          {icon}
        </span>
      </div>
      <div style={styles.statValue(colors, isMobile)}>{value}</div>
      {change && (
        <div
          style={{
            ...styles.statChange(isMobile),
            color: positive ? "#10B981" : "#EF4444",
          }}
        >
          {positive ? (
            <ArrowUp size={isMobile ? 10 : 12} />
          ) : (
            <ArrowDown size={isMobile ? 10 : 12} />
          )}
          {change}
        </div>
      )}
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Quick stat
   ══════════════════════════════════════════════════════════ */

const QuickStat = memo(function QuickStat({
  label,
  value,
  icon,
  color,
  colors,
  isMobile,
}) {
  return (
    <div style={styles.quickCard(colors, isMobile)}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={styles.quickLabel(colors, isMobile)}>{label}</div>
        <div style={styles.quickValue(colors, isMobile)}>{value}</div>
      </div>
      <span
        style={{
          color,
          opacity: 0.6,
          display: "inline-flex",
          flexShrink: 0,
          marginLeft: 8,
        }}
      >
        {icon}
      </span>
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Registration fees
   ══════════════════════════════════════════════════════════ */

const RegistrationFeesCard = memo(function RegistrationFeesCard({
  colors,
  isMobile,
  fees,
  isEditing,
  isSaving,
  editData,
  onChange,
  onEdit,
  onCancel,
  onSave,
}) {
  return (
    <div style={styles.feesCard(colors, isMobile)}>
      <div style={styles.feesHeader}>
        <div style={styles.feesTitleWrap}>
          <Coins size={isMobile ? 16 : 18} color={colors.btnBg} />
          <span style={styles.feesTitle(colors, isMobile)}>
            Registration Fees
          </span>
          {fees?.updated_by_username && (
            <span style={styles.feesBy(colors, isMobile)}>
              by {fees.updated_by_username}
            </span>
          )}
        </div>

        {!isEditing ? (
          <button
            type="button"
            onClick={onEdit}
            style={styles.feesEditBtn(colors, isMobile)}
          >
            <Edit2 size={isMobile ? 13 : 14} />
            Edit
          </button>
        ) : (
          <div style={{ display: "flex", gap: 6 }}>
            <button
              type="button"
              onClick={onCancel}
              style={styles.feesCancelBtn(colors, isMobile)}
            >
              <X size={isMobile ? 13 : 14} />
              Cancel
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={isSaving}
              style={styles.feesSaveBtn(colors, isSaving, isMobile)}
            >
              {isSaving ? (
                <>
                  <span style={styles.spinnerSmall(colors)} />
                  Saving…
                </>
              ) : (
                <>
                  <Save size={isMobile ? 13 : 14} />
                  Save
                </>
              )}
            </button>
          </div>
        )}
      </div>

      <div style={styles.feesGrid(isMobile)}>
        <FeeField
          colors={colors}
          isMobile={isMobile}
          label="Agent Registration Fee"
          value={fees?.agent_registration_fee || "0.00"}
          editing={isEditing}
          name="agent_registration_fee"
          editValue={editData.agent_registration_fee}
          onChange={onChange}
          tone={colors.btnBg}
        />
        <FeeField
          colors={colors}
          isMobile={isMobile}
          label="Sub-Agent Registration Fee"
          value={fees?.sub_agent_registration_fee || "0.00"}
          editing={isEditing}
          name="sub_agent_registration_fee"
          editValue={editData.sub_agent_registration_fee}
          onChange={onChange}
          tone="#8B5CF6"
        />
      </div>

      {fees?.updated_at && !isEditing && (
        <div style={styles.feesUpdatedAt(colors, isMobile)}>
          Last updated: {formatDate(fees.updated_at)}
        </div>
      )}
    </div>
  );
});

const FeeField = memo(function FeeField({
  colors,
  isMobile,
  label,
  value,
  editing,
  name,
  editValue,
  onChange,
  tone,
}) {
  return (
    <div>
      <div style={styles.feeLabel(colors, isMobile)}>{label}</div>
      {editing ? (
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <span
            style={{
              position: "absolute",
              left: 12,
              color: colors.secondaryText,
              fontWeight: 700,
              fontSize: isMobile ? 14 : 15,
              pointerEvents: "none",
            }}
          >
            ₵
          </span>
          <input
            type="text"
            name={name}
            value={editValue}
            onChange={onChange}
            style={styles.feeInput(colors, isMobile)}
          />
        </div>
      ) : (
        <div
          style={{
            fontSize: isMobile ? 20 : 24,
            fontWeight: 800,
            color: tone,
            letterSpacing: "-0.01em",
          }}
        >
          ₵{value}
        </div>
      )}
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Chart card
   ══════════════════════════════════════════════════════════ */

const ChartCard = memo(function ChartCard({
  colors,
  isMobile,
  chartData,
  activeTab,
  setActiveTab,
}) {
  const dataMap = useMemo(
    () => ({
      revenue: { data: chartData.revenue, color: colors.btnBg, label: "Revenue" },
      profit: { data: chartData.profit, color: "#10B981", label: "Profit" },
      orders: { data: chartData.orders, color: "#F59E0B", label: "Orders" },
      users: { data: chartData.users, color: "#8B5CF6", label: "New Users" },
    }),
    [chartData, colors.btnBg]
  );

  const current = dataMap[activeTab];
  const maxValue = useMemo(
    () => Math.max(...current.data, 1),
    [current.data]
  );

  return (
    <div style={styles.chartCard(colors, isMobile)}>
      <div style={styles.chartHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <BarChart3 size={isMobile ? 15 : 17} color={colors.btnBg} />
          <span style={styles.chartTitle(colors, isMobile)}>Analytics</span>
        </div>
        <div style={styles.chartSummary(colors, isMobile)}>
          <span>
            Orders{" "}
            <strong style={{ color: colors.text }}>
              {chartData.summary.total_orders || 0}
            </strong>
          </span>
          <span>
            Revenue{" "}
            <strong style={{ color: colors.text }}>
              ₵{parseFloat(chartData.summary.total_revenue || 0).toFixed(2)}
            </strong>
          </span>
        </div>
      </div>

      <div style={styles.chartTabsWrap}>
        <span style={styles.chartTabLabel(colors, isMobile)}>
          {current.label}
        </span>
        <div style={styles.chartTabRow}>
          {CHART_TABS.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(tab)}
              style={styles.chartTab(colors, activeTab === tab, isMobile)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div style={styles.chartBody(isMobile)}>
        {current.data.map((value, i) => {
          const pct = (value / maxValue) * 100;
          const height = Math.max(pct, 3);
          return (
            <div key={i} style={styles.chartBarCol}>
              <div style={styles.chartBarWrap}>
                <div
                  style={{
                    ...styles.chartBar(current.color, height),
                    transformOrigin: "bottom",
                    animation: "ad-barGrow 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both",
                    animationDelay: `${i * 40}ms`,
                  }}
                >
                  {value > 0 && (
                    <span
                      style={{
                        ...styles.chartBarValue(current.color, isMobile),
                      }}
                    >
                      {value}
                    </span>
                  )}
                </div>
              </div>
              <span style={styles.chartBarLabel(colors, isMobile)}>
                {chartData.labels[i]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Recent orders
   ══════════════════════════════════════════════════════════ */

const RecentOrdersCard = memo(function RecentOrdersCard({
  colors,
  isMobile,
  orders,
  onViewAll,
}) {
  return (
    <div style={styles.listCard(colors)}>
      <div style={styles.listHeader(colors, isMobile)}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <ShoppingBag size={isMobile ? 13 : 15} color={colors.btnBg} />
          <span style={styles.listTitle(colors, isMobile)}>Recent Orders</span>
        </div>
        <button type="button" onClick={onViewAll} style={styles.viewAllBtn(colors, isMobile)}>
          View all <ChevronRight size={12} />
        </button>
      </div>

      {orders.length === 0 ? (
        <div style={styles.listEmpty(colors, isMobile)}>No recent orders</div>
      ) : (
        orders.map((order) => (
          <div
            key={order.id}
            style={styles.orderRow(isMobile)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = colors.hoverBg)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
          >
            <span style={styles.orderIdCell(colors, isMobile)}>
              {order.id?.slice(0, 8) || "N/A"}
            </span>
            <span style={styles.orderCustomerCell(colors, isMobile)}>
              {order.customer?.username || order.customer_username || "N/A"}
            </span>
            <span style={styles.orderAmountCell(colors, isMobile)}>
              ₵{order.customer_price || "0.00"}
            </span>
            <span
              style={{
                ...styles.orderStatusCell(isMobile),
                color: getStatusColor(order.status),
              }}
            >
              <StatusIcon status={order.status} size={11} />
              {isMobile
                ? getStatusLabel(order.status).slice(0, 3)
                : getStatusLabel(order.status)}
            </span>
          </div>
        ))
      )}
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Recent users   ══════════════════════════════════════════════════════════ */

const RecentUsersCard = memo(function RecentUsersCard({
  colors,
  isMobile,
  users,
  onViewAll,
}) {
  return (
    <div style={styles.listCard(colors)}>
      <div style={styles.listHeader(colors, isMobile)}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Users size={isMobile ? 13 : 15} color={colors.btnBg} />
          <span style={styles.listTitle(colors, isMobile)}>New Users</span>
        </div>
        <button type="button" onClick={onViewAll} style={styles.viewAllBtn(colors, isMobile)}>
          View all <ChevronRight size={12} />
        </button>
      </div>

      {users.length === 0 ? (
        <div style={styles.listEmpty(colors, isMobile)}>No recent users</div>
      ) : (
        users.map((u) => {
          const roleColor = getRoleColor(u.role);
          return (
            <div
              key={u.id}
              style={styles.userRow(isMobile)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = colors.hoverBg)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <div style={styles.userAvatarWrap}>
                <div
                  style={{
                    ...styles.userAvatar(roleColor, isMobile),
                  }}
                >
                  {(u.first_name?.[0] || u.username?.[0] || "U").toUpperCase()}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={styles.userName(colors, isMobile)}>
                    {u.first_name || u.username}
                    {u.last_name && ` ${u.last_name}`}
                  </div>
                  <div style={styles.userEmail(colors, isMobile)}>
                    {u.email}
                  </div>
                </div>
              </div>
              <span style={styles.userRolePill(roleColor, isMobile)}>
                {isMobile ? getRoleLabel(u.role).slice(0, 4) : getRoleLabel(u.role)}
              </span>
            </div>
          );
        })
      )}
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Top packages
   ══════════════════════════════════════════════════════════ */

const TopPackagesCard = memo(function TopPackagesCard({
  colors,
  isMobile,
  packages,
}) {
  return (
    <div style={styles.listCard(colors)}>
      <div style={styles.listHeader(colors, isMobile)}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Award size={isMobile ? 13 : 15} color={colors.btnBg} />
          <span style={styles.listTitle(colors, isMobile)}>Top Packages</span>
        </div>
        <span style={styles.packagesSubtitle(colors, isMobile)}>
          By sales volume
        </span>
      </div>

      <div style={styles.packagesGrid(isMobile)}>
        {packages.length === 0 ? (
          <div style={styles.packagesEmpty(colors, isMobile)}>
            No package data available
          </div>
        ) : (
          packages.map((pkg, i) => (
            <div
              key={pkg.id || i}
              style={styles.packageCard(colors, isMobile)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${colors.shadow}`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={styles.packageNetwork(colors, isMobile)}>
                  {pkg.network}
                </div>
                <div style={styles.packageMeta(colors, isMobile)}>
                  {pkg.size_gb}GB • {pkg.sales_count || 0} sales
                </div>
              </div>
              <div style={styles.packageRevenue(colors, isMobile)}>
                ₵{parseFloat(pkg.total_revenue || 0).toFixed(2)}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
});

/* ══════════════════════════════════════════════════════════
   Styles
   ══════════════════════════════════════════════════════════ */

const styles = {
  pageWrap: {
    maxWidth: 1240,
    margin: "0 auto",
    padding: "20px 16px 60px",
    fontFamily: "inherit",
  },

  /* Header */
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  h1: (c, m) => ({
    margin: 0,
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontSize: m ? 20 : 24,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.02em",
  }),
  subtitle: (c, m) => ({
    margin: "4px 0 0",
    fontSize: m ? 12 : 13,
    color: c.secondaryText,
  }),
  headerActions: { display: "flex", gap: 8, alignItems: "center" },
  ghostBtn: (c, busy) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 14px",
    borderRadius: 10,
    border: `1px solid ${c.border}`,
    background: c.raisedBg,
    color: c.text,
    fontSize: 12.5,
    fontWeight: 600,
    cursor: busy ? "not-allowed" : "pointer",
    opacity: busy ? 0.7 : 1,
    fontFamily: "inherit",
  }),

  /* Grids */
  statsGrid: (m) => ({
    display: "grid",
    gridTemplateColumns: m
      ? "repeat(2, minmax(0, 1fr))"
      : "repeat(4, minmax(0, 1fr))",
    gap: m ? 8 : 10,
    marginBottom: m ? 12 : 16,
  }),
  quickGrid: (m) => ({
    display: "grid",
    gridTemplateColumns: m
      ? "repeat(2, minmax(0, 1fr))"
      : "repeat(4, minmax(0, 1fr))",
    gap: m ? 6 : 8,
    marginBottom: m ? 12 : 16,
  }),
  twoCol: (m) => ({
    display: "grid",
    gridTemplateColumns: m ? "1fr" : "1fr 1fr",
    gap: m ? 12 : 16,
    marginBottom: m ? 12 : 16,
  }),

  /* Stat card */
  statCard: (c, m) => ({
    padding: m ? "10px 12px" : "14px 16px",
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  }),
  statTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  statLabel: (c, m) => ({
    fontSize: m ? 9.5 : 11,
    fontWeight: 600,
    color: c.secondaryText,
  }),
  statValue: (c, m) => ({
    fontSize: m ? 18 : 22,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.01em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  statChange: (m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    fontSize: m ? 9 : 10.5,
    fontWeight: 600,
    marginTop: 4,
  }),

  /* Quick card */
  quickCard: (c, m) => ({
    padding: m ? "8px 10px" : "10px 14px",
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 6,
  }),
  quickLabel: (c, m) => ({
    fontSize: m ? 8.5 : 10,
    fontWeight: 600,
    color: c.secondaryText,
  }),
  quickValue: (c, m) => ({
    fontSize: m ? 15 : 17,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.01em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),

  /* Fees */
  feesCard: (c, m) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 12,
    padding: m ? "14px 16px" : "16px 20px",
    marginBottom: m ? 12 : 16,
  }),
  feesHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 12,
  },
  feesTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  feesTitle: (c, m) => ({
    fontSize: m ? 14 : 15,
    fontWeight: 800,
    color: c.heading,
  }),
  feesBy: (c, m) => ({
    fontSize: m ? 9.5 : 10.5,
    color: c.secondaryText,
  }),
  feesEditBtn: (c, m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: m ? "5px 10px" : "6px 12px",
    borderRadius: 8,
    border: `1px solid ${c.border}`,
    background: "transparent",
    color: c.text,
    fontSize: m ? 11.5 : 12,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "inherit",
  }),
  feesCancelBtn: (c, m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: m ? "5px 10px" : "6px 12px",
    borderRadius: 8,
    border: `1px solid ${c.border}`,
    background: "transparent",
    color: c.text,
    fontSize: m ? 11.5 : 12,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "inherit",
  }),
  feesSaveBtn: (c, busy, m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: m ? "5px 10px" : "6px 12px",
    borderRadius: 8,
    border: "none",
    background: c.btnBg,
    color: c.btnText,
    fontSize: m ? 11.5 : 12,
    fontWeight: 700,
    cursor: busy ? "not-allowed" : "pointer",
    opacity: busy ? 0.7 : 1,
    fontFamily: "inherit",
  }),
  spinnerSmall: (c) => ({
    width: 12,
    height: 12,
    border: `2px solid ${c.btnText}55`,
    borderTopColor: c.btnText,
    borderRadius: "50%",
    animation: "ad-spin 0.8s linear infinite",
    display: "inline-block",
  }),
  feesGrid: (m) => ({
    display: "grid",
    gridTemplateColumns: m ? "1fr" : "1fr 1fr",
    gap: m ? 12 : 16,
  }),
  feeLabel: (c, m) => ({
    fontSize: m ? 11 : 12,
    fontWeight: 600,
    color: c.secondaryText,
    marginBottom: 6,
  }),
  feeInput: (c, m) => ({
    width: "100%",
    padding: m ? "8px 12px 8px 28px" : "10px 14px 10px 32px",
    borderRadius: 8,
    border: `1.5px solid ${c.btnBg}`,
    background: c.raisedBg,
    color: c.text,
    fontSize: m ? 13.5 : 15,
    fontWeight: 700,
    outline: "none",
    fontFamily: "inherit",
    boxShadow: `0 0 0 3px ${c.btnBg}20`,
  }),
  feesUpdatedAt: (c, m) => ({
    fontSize: m ? 9.5 : 10.5,
    color: c.secondaryText,
    marginTop: 12,
    paddingTop: 12,
    borderTop: `1px solid ${c.border}`,
  }),

  /* Chart */
  chartCard: (c, m) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 12,
    padding: m ? "12px 14px" : "16px 18px",
    marginBottom: m ? 12 : 16,
    boxShadow: `0 2px 8px ${c.shadow}`,
  }),
  chartHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 10,
  },
  chartTitle: (c, m) => ({
    fontSize: m ? 13 : 14.5,
    fontWeight: 800,
    color: c.heading,
  }),
  chartSummary: (c, m) => ({
    display: "flex",
    gap: m ? 8 : 12,
    fontSize: m ? 10 : 11,
    color: c.secondaryText,
    flexWrap: "wrap",
  }),
  chartTabsWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 8,
  },
  chartTabLabel: (c, m) => ({
    fontSize: m ? 11 : 12,
    fontWeight: 600,
    color: c.secondaryText,
  }),
  chartTabRow: { display: "flex", gap: 3, flexWrap: "wrap" },
  chartTab: (c, active, m) => ({
    padding: m ? "4px 9px" : "5px 11px",
    borderRadius: 6,
    border: "none",
    background: active ? c.btnBg : "transparent",
    color: active ? c.btnText : c.secondaryText,
    fontSize: m ? 9.5 : 10.5,
    fontWeight: active ? 700 : 500,
    cursor: "pointer",
    fontFamily: "inherit",
    textTransform: "capitalize",
  }),
  chartBody: (m) => ({
    display: "flex",
    alignItems: "flex-end",
    gap: m ? 4 : 6,
    height: m ? 120 : 160,
    padding: "0 2px",
  }),
  chartBarCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "flex-end",
    gap: 4,
  },
  chartBarWrap: {
    width: "100%",
    maxWidth: 32,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-end",
    height: "100%",
  },
  chartBar: (color, height) => ({
    width: "100%",
    height: `${height}%`,
    minHeight: 3,
    background: `linear-gradient(180deg, ${color}, ${color}88)`,
    borderRadius: "3px 3px 0 0",
    position: "relative",
    boxShadow: `0 2px 8px ${color}33`,
  }),
  chartBarValue: (color, m) => ({
    position: "absolute",
    top: m ? -12 : -15,
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: m ? 7.5 : 9,
    fontWeight: 700,
    color,
    opacity: 0.85,
    whiteSpace: "nowrap",
  }),
  chartBarLabel: (c, m) => ({
    fontSize: m ? 8 : 9,
    fontWeight: 500,
    color: c.secondaryText,
  }),

  /* List cards */
  listCard: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 12,
    overflow: "hidden",
  }),
  listHeader: (c, m) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: m ? "10px 12px" : "12px 16px",
    borderBottom: `1px solid ${c.border}`,
    gap: 8,
    flexWrap: "wrap",
  }),
  listTitle: (c, m) => ({
    fontSize: m ? 12.5 : 13.5,
    fontWeight: 800,
    color: c.heading,
  }),
  viewAllBtn: (c, m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    background: "transparent",
    border: "none",
    color: c.btnBg,
    fontSize: m ? 11 : 12,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "inherit",
  }),
  listEmpty: (c, m) => ({
    padding: m ? "20px 12px" : "28px 16px",
    textAlign: "center",
    fontSize: m ? 12 : 13,
    color: c.secondaryText,
  }),

  /* Order rows */
  orderRow: (m) => ({
    display: "grid",
    gridTemplateColumns: m
      ? "minmax(60px, 0.7fr) 1fr minmax(60px, 0.7fr) minmax(60px, 0.7fr)"
      : "minmax(70px, 0.8fr) 1fr minmax(80px, 0.8fr) minmax(80px, 0.8fr)",
    gap: m ? 4 : 6,
    padding: m ? "8px 12px" : "10px 16px",
    borderBottom: "1px solid transparent",
    alignItems: "center",
    fontSize: m ? 11 : 12,
    transition: "background 0.12s ease",
  }),
  orderIdCell: (c, m) => ({
    fontSize: m ? 10 : 11,
    fontWeight: 700,
    color: c.heading,
  }),
  orderCustomerCell: (c, m) => ({
    fontSize: m ? 10.5 : 12,
    color: c.text,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  orderAmountCell: (c, m) => ({
    fontSize: m ? 11 : 12,
    fontWeight: 700,
    color: c.btnBg,
  }),
  orderStatusCell: (m) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    fontSize: m ? 9 : 10,
    fontWeight: 700,
    textTransform: "capitalize",
  }),

  /* User rows */
  userRow: (m) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    padding: m ? "8px 12px" : "10px 16px",
    borderBottom: "1px solid transparent",
    transition: "background 0.12s ease",
  }),
  userAvatarWrap: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
    flex: 1,
  },
  userAvatar: (color, m) => ({
    width: m ? 26 : 30,
    height: m ? 26 : 30,
    borderRadius: "50%",
    background: `${color}1F`,
    color,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: m ? 10 : 12,
    flexShrink: 0,
  }),
  userName: (c, m) => ({
    fontSize: m ? 11 : 12.5,
    fontWeight: 700,
    color: c.heading,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  userEmail: (c, m) => ({
    fontSize: m ? 9.5 : 10.5,
    color: c.secondaryText,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  userRolePill: (color, m) => ({
    padding: m ? "1px 6px" : "2px 8px",
    borderRadius: 999,
    background: `${color}1F`,
    color,
    fontSize: m ? 8.5 : 9.5,
    fontWeight: 700,
    letterSpacing: 0.3,
    textTransform: "uppercase",
    flexShrink: 0,
  }),

  /* Packages */
  packagesSubtitle: (c, m) => ({
    fontSize: m ? 10 : 11,
    color: c.secondaryText,
  }),
  packagesGrid: (m) => ({
    display: "grid",
    gridTemplateColumns: m
      ? "repeat(2, minmax(0, 1fr))"
      : "repeat(auto-fill, minmax(220px, 1fr))",
    gap: m ? 6 : 10,
    padding: m ? "10px 12px" : "12px 16px",
  }),
  packagesEmpty: (c, m) => ({
    gridColumn: "1 / -1",
    padding: m ? "20px 12px" : "28px 16px",
    textAlign: "center",
    fontSize: m ? 12 : 13,
    color: c.secondaryText,
  }),
  packageCard: (c, m) => ({
    padding: m ? "8px 10px" : "12px 14px",
    background: c.mainBg,
    border: `1px solid ${c.border}`,
    borderRadius: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
  }),
  packageNetwork: (c, m) => ({
    fontSize: m ? 10.5 : 12,
    fontWeight: 800,
    color: c.heading,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  }),
  packageMeta: (c, m) => ({
    fontSize: m ? 9.5 : 10.5,
    color: c.secondaryText,
    marginTop: 2,
  }),
  packageRevenue: (c, m) => ({
    fontSize: m ? 12 : 14,
    fontWeight: 800,
    color: c.btnBg,
    letterSpacing: "-0.01em",
  }),

  /* Loading */
  loadingBox: (c) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 400,
    gap: 12,
  }),
  spinner: (c) => ({
    width: 32,
    height: 32,
    border: `3px solid ${c.border}`,
    borderTopColor: c.btnBg,
    borderRadius: "50%",
    animation: "ad-spin 0.8s linear infinite",
  }),
};

export default AdminDashboard;